import React, { useEffect, useState, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import { useSelector } from "react-redux";
import OverlappingMarkerSpiderfier from 'overlapping-marker-spiderfier';
import { Col } from 'react-bootstrap';
import { toast } from 'react-toastify';


import APICom from "../../utils/helpers/APICom";
import DispatchAction from '../Dispatch/DispatchAction';
import PersistStorage from '../../utils/helpers/PersistStorage.js';
import DateTimeUtils from '../../utils/DateTimeUtility.js';
import CommonFunctions from '../../utils/helpers/CommonFunctions.js';

import PUIcon from "../../assets/Images/MapImages/PUMarker.png";
import CompletedIcon from "../../assets/Images/MapImages/MarkerCompleted.png";
import UnroutedMarkerIcon from "../../assets/Images/MapImages/UnRoutedMarker.png";
import UnroutedMarkerDOIcon from "../../assets/Images/MapImages/UnRoutedMarkerDO.png";
import CabOffline from "../../assets/Images/MapImages/Cab_Offline.png";
import CabDisconnected from "../../assets/Images/MapImages/Cab_Disconnected.png";
import LiftOccupied from "../../assets/Images/MapImages/Lift_OCCUPIED.png";
import LiftOnline from "../../assets/Images/MapImages/Lift_ONLINE.png";
import SedanOccupied from "../../assets/Images/MapImages/Sedan_OCCUPIED.png";
import SedanOnline from "../../assets/Images/MapImages/Sedan_Online.png";
import VanOccupied from "../../assets/Images/MapImages/VAN_OCCUPIED.png";
import VanOnline from "../../assets/Images/MapImages/VAN_ONLINE.png";
import DepotIcon from "../../assets/Images/MapImages/depotIconBtn.png";
import ZoneIcon from "../../assets/Images/MapImages/zonesIcon.png";
import ZoomLockIcon from "../../assets/Images/MapImages/zoomLockIcon.png";
import nullifyIcon from "../../assets/Images/MapImages/nullifyMapIcon.png";
import VehicleNotAssigned from "../../assets/Images/CommonImages/cancel_icon.png";
import RouteRemovalIcon from "../../assets/Images/MapImages/routeDelIcon.png";
import SDepot from "../../assets/Images/MapImages/StartDepotIcon.png";
import EDepot from "../../assets/Images/MapImages/EndDepotIcon.png";
import completedCheck from "../../assets/Images/MapImages/check1.png";
import completedCheck2 from "../../assets/Images/MapImages/check2.png";


const MapControl = (props = {}) => {
    const { ASCSSettingData, AffiliateData } = useSelector((store) => store.combinedata); 

    // Retrieve center coordinates
    // let startCenterLat, startCenterLng;
    // startCenterLat = defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")?.value : 39.16552683625823;
    // startCenterLng = defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")?.value : -77.16834351718929;

    // if (!startCenterLat || !startCenterLng) {
    //     // Default to ASCSSettingData or fallback values
    //     startCenterLat = defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")?.value : 39.16552683625823;
    //     startCenterLng = defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")?.value : -77.16834351718929;
    // }

    const selectedRowTripType = useRef("");
    
    const [zoomOpt, setZoomOpt] = useState({zoomControl: true, draggable: true, scrollWheel: true, disableDoubleClickZoom: false});
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [dynamicHeight, setMapDivHeight] = useState({});
    const [GlobalMapsObjects, setGlobalMapsObjects] = useState({});
    const [markers, setMarkers] = useState([]);
    const [depotMarkers, setDepotMarkers] = useState([]);
    const [depotInfo, setDepotInfo] = useState([]);
    const [PolyPaths, setPolyPaths] = useState([]);
    const [MapPopoutCreated, setMapPopoutCreated] = useState(false);
    const [showDepotSelected, setShowDepotSelected] = useState(false);
    const [routeRemovalCreated, setRouteRemovalCreated] = useState(false);
    const [MapZoomCreated, setMapZoomCreated] = useState(false);
    const [MapZoneCreated, setMapZoneCreated] = useState(false);
    const [MapInfoDivCreated, setMapInfoDivCreated] = useState(false);
    const [MapDepotCreated, setMapDepotCreated] = useState(false);
    const [MapShowVehicle, setMapShowVehicle] = useState(false);
    const [MapMarkerRemovalCreated, setMapMarkerRemovalCreated] = useState(false);
    const [vehicleTableCreated, setvehicleTableCreated] = useState(false);
    const [vehicleTableData, setVehicleTableData] = useState([]);
    const [infowindows, setinfowindows] = useState([]);
    const [invokeDispatchComponent, setinvokeDispatchComponent] = useState(false);
    const [dispatchVehicleID, setDispatchVehicleID] = useState(-1);
    const [dispatchDriverID, setDispatchDriverID] = useState(-1);
    const [MapPreviousInfoDivCreated, setMapPreviousInfoDivCreated] = useState(false);
    const [IsShowCompleted, setIsShowCompleted] = useState(false);
    const [affSelected, setAffSelected] = useState(()=> {
        let familySelectionMemory = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
        if(props.selectedAffiliates && props.selectedAffiliates !== ''){
            return props.selectedAffiliates;
        }
        else {
            return familySelectionMemory;
        }
    });
    const [IsShowOccupiedVehcilesChecked, setIsShowOccupiedVehcilesChecked] = useState(false);
    const IsShowOccupiedVehiclesCheckBoxAdded = useState(false);

    const selectedAff = useRef(affSelected);
    const defaultSettings = useRef((selectedAff.current && ASCSSettingData[selectedAff.current] ? JSON.parse(ASCSSettingData[selectedAff.current]): null));
    const startCenterInfo = useRef({ 
        centerLat: (defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")?.value : 39.16552683625823), 
        centerLng: (defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")?.value : -77.16834351718929)
    });
    const mapCenterRef = useRef({lat:parseFloat(startCenterInfo.current.centerLat), lng:parseFloat(startCenterInfo.current.centerLng)});
    const lastUserZoomLevel = useRef((PersistStorage.retrieve("lastUserZoomLevel", false) ? PersistStorage.retrieve("lastUserZoomLevel", false) : null));
    const ITCMapURL = useRef(
        (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
        (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value:"http://itcmap.itcurves.us/api/Map/")
    );
    const OSRM_Username = useRef(
        (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
        (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value:"annapolis")
    );
    const OSRM_Password = useRef(
        (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
        (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value:"barwoodpass")
    );
    const selectedDate = useRef(props.selectedDate);
    const addedUnroutedTrip = useRef(null);
    const singleClickUnroutedTrips = useRef(null);
    const additionalTrip = useRef([]);
    const keepZoneRef = useRef(false);
    const clusterTripsChangeRef = useRef([]);
    const routeLinesRef = useRef([]);
    const singleRoutePolylineRef = useRef([]);
    const originalInfoRef = useRef("");
    const vehImage = useRef([]);
    const vehDataRef = useRef([]);
    const MapShowCompletedRef = useRef();
    const IsCalledFromAffiliateChange = useRef(false);

    let state = {
        center: mapCenterRef.current ,//{lat:39.16552683625823, lng:-77.16834351718929}, // IT Curves coordinates
        zoom: lastUserZoomLevel.current,
        tilt: 47.5,
        mapheight: props.options.mapHeight,
        heightoffset: 183,
        mapId: "90f87356969d889c",
        options: {
            gestureHandling: 'greedy',
            zoomControl: zoomOpt.zoomControl,
            draggable: zoomOpt.draggable,
            scrollWheel: zoomOpt.scrollWheel,
            disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom,
        },
        places: props.MapDetailData,
        commonStyles: {fontFamily: "Roboto,Arial,sans-serif", padding: '0 5px', margin: '10px 0 22px', color: 'rgb(25,25,25)', textAlign: 'center', lineHeight: "38px"}
    };
    
    state = {...state, ...props.options};

    let polygons = [];

    useEffect( () => {
        // debugger
        if(selectedAff.current === '' || !selectedAff.current){
            let familySelectionMemory = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
            reAdjustMapCenter(familySelectionMemory);
            ITCMapURL.current = (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
                (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value:"http://itcmap.itcurves.us/api/Map/"
            );
            OSRM_Password.current = (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
                (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value:"barwoodpass"
            );
            OSRM_Username.current = (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
                (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value:"annapolis"
            );
        }
        window.addEventListener('resize', handleResize);
        // window.addEventListener('beforeunload', localStorage.removeItem("placeInfo"));
        return() => {
            RemoveAllMapObjects();
            // window.removeEventListener('beforeunload', localStorage.removeItem("placeInfo"));
        };
    }, []);

    useEffect(() => {
        // Call the function when currentState changes and previousState is not null
        if (props.clusterTableStateBeforeCompute) {
            const infoDivPrevious = createMapInfoDivPrevious(GlobalMapsObjects.map, GlobalMapsObjects.maps, props.clusterTableStateBeforeCompute, [])
            if(MapPreviousInfoDivCreated)
            {
                setMapInfoDivCreated(false);
                removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['TOP_LEFT'], index: [0]});
                // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                // {
                //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                   
                // }
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].push(infoDivPrevious);
                setMapPreviousInfoDivCreated(true);
            }
            else{
                setMapInfoDivCreated(false);
                removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['TOP_LEFT'], index: [0]});
                // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                // {
                //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                // }
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].push(infoDivPrevious);
                setMapPreviousInfoDivCreated(true);
            }
        }
        else{
            if(MapPreviousInfoDivCreated)
            {
                
                setMapPreviousInfoDivCreated(false);
                removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['TOP_LEFT'], index: [0]});
                // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                // {
                //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                // }
                const infoDiv = createMapInfoDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places, []);
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].push(infoDiv);
                setMapInfoDivCreated(true);
            }
        }
        
    }, [props.clusterTableStateBeforeCompute]);
    
    useEffect( ()=>{
        try{
            if(typeof GlobalMapsObjects.map !== 'undefined' && props.arrangedTripsClusterData.length > 0){
                clusterTripsChangeRef.current = [];
                for(let k = 0; k < props.arrangedTripsClusterData.length; k++)
                {
                    let mapInfo = null;
                    let eta = null;
                    if(props.arrangedTripsClusterData[k].Type === "PU")
                    {
                        mapInfo = new GlobalMapsObjects.maps.LatLng(parseFloat(props.arrangedTripsClusterData[k].dLatitude), parseFloat(props.arrangedTripsClusterData[k].dLongitude));
                        eta = (props.arrangedTripsClusterData[k].SchTime === ""? props.arrangedTripsClusterData[k].ReqTime:props.arrangedTripsClusterData[k].SchTime);
                        clusterTripsChangeRef.current.push({trip:"P", latLng: mapInfo, time: eta});
                    }
                    else if(props.arrangedTripsClusterData[k].Type === "DO")
                    {
                        mapInfo = new GlobalMapsObjects.maps.LatLng(parseFloat(props.arrangedTripsClusterData[k].dLatitude), parseFloat(props.arrangedTripsClusterData[k].dLongitude));
                        eta = (props.arrangedTripsClusterData[k].SchTime === ""? props.arrangedTripsClusterData[k].ReqTime:props.arrangedTripsClusterData[k].SchTime);
                        clusterTripsChangeRef.current.push({trip:"D", latLng: mapInfo, time: eta});  
                    }
                    
                }
                if(PolyPaths.length > 0)
                {
                    for(let i = 0; i < PolyPaths.length; i++) {
                        PolyPaths[i].setMap(null);
                    }
                    if(singleRoutePolylineRef.current !== undefined && singleRoutePolylineRef.current.length > 0 && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current.forEach(item=>{
                            item.setMap(GlobalMapsObjects.map);
                            PolyPaths.push(item);
                        });
                        setPolyPaths(PolyPaths);
                    }
                    getStraightPolylines(clusterTripsChangeRef.current, GlobalMapsObjects.map, GlobalMapsObjects.maps);
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.arrangedTripsClusterData]);

    useEffect( ()=>{
        try{                
            if(state.places.length > 0)
            {
                addedUnroutedTrip.current = props.routedTrip;
                if(addedUnroutedTrip.current)
                {
                    if(addedUnroutedTrip.current.data !== "" /*&& state.places[0].Route !== ""*/)
                    {
                        handleAddingNewTrip(addedUnroutedTrip.current.data);
                    }
                    else if(addedUnroutedTrip.current.data === "" && state.places[0].Route !== "" && markers.length > 0)
                    {
                        additionalTrip.current = [];
                        if(markers.length > 0 && markers[(markers.length-1)].label?.text?.length === 1){
                            for(let i = 0; i < markers.length; i++) {
                                if(i === (markers.length-1))
                                {
                                    markers[i].setMap(null);
                                }
                                else if(i === (markers.length-2))
                                {
                                    markers[i].setMap(null);
                                }
                            }
                            for(let i = 0; i < PolyPaths.length; i++) {
                                if(PolyPaths[i].strokeColor === "brown")
                                {
                                    PolyPaths[i].setMap(null);
                                }
                            }
                            
                        }
                    }
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.routedTrip]);

    useEffect(() => {
        setIsShowCompleted(props.IsCheckCompletedTrips);
    }, [props.IsCheckCompletedTrips])

    useEffect( ()=>{
        try{   
            addedUnroutedTrip.current = props.unroutedTrip;
            if(state.places.length > 0)
            {
                if(addedUnroutedTrip.current)
                {
                    if(addedUnroutedTrip.current.data !== "" && addedUnroutedTrip?.current?.data?.length > 0 /*&& state.places[0].Route === ""*/)
                    {
                        handleAddingNewTrip(addedUnroutedTrip.current.data);
                    }
                    else if(addedUnroutedTrip.current.data === "" && state.places[0].Route === "" && markers.length > 0)
                    {
                        additionalTrip.current = [];
                        if(markers.length > 0 && markers[(markers.length-1)].label?.text?.length === 1){
                            for(let i = 0; i < markers.length; i++) {
                                if(i === (markers.length-1))
                                {
                                    markers[i].setMap(null);
                                }
                                else if(i === (markers.length-2))
                                {
                                    markers[i].setMap(null);
                                }
                            }
                            for(let i = 0; i < PolyPaths.length; i++) {
                                if(PolyPaths[i].strokeColor === "brown")
                                {
                                    PolyPaths[i].setMap(null);
                                }
                            }
                            
                        }
                    }
                }
            }
            else
            {
                singleClickUnroutedTrips.current = props.unroutedTrip;
                if(singleClickUnroutedTrips.current?.data !== "" && singleClickUnroutedTrips.current?.data?.length > 0)
                {
                    handleAddingNewTrip(singleClickUnroutedTrips.current.data, false);
                }
                else if(singleClickUnroutedTrips.current?.data === "")
                {
                    additionalTrip.current = [];
                    RemoveAllMapObjects();
                    props.setDetailDataFunc([]);
                    if(typeof GlobalMapsObjects.map !== 'undefined')
                    {
                        GlobalMapsObjects.map.setCenter(mapCenterRef.current);
                        GlobalMapsObjects.map.setZoom(state.zoom);
                    } 
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.unroutedTrip]);

    useEffect( () => {
        if(typeof GlobalMapsObjects.map !== 'undefined'){
            clusterTripsChangeRef.current = [];
            setMapInfoDivCreated(false);
            removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['TOP_LEFT'], index: [0]});
            // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
            // {
            //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
            // }
            if(routeRemovalCreated)
            {
                removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['LEFT_BOTTOM'], index: [2]});
                // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                // {
                //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                // }
                // const routeRemDiv = document.createElement("div");
                const routeRemDivBtn = createRouteRemovalBtn(GlobalMapsObjects.map, GlobalMapsObjects.maps);

                const routeRemDiv = CommonFunctions.CreateElement("div", {
                    styles: {
                        margin: '10px',
                    },
                    attributes: {
                        id: state.GridName + "_RouteRemDiv"
                    },
                    children: [routeRemDivBtn]
                });
                
                // routeRemDiv.style.margin = "10px"; 
                // routeRemDiv.id = state.GridName + "_RouteRemDiv";
                // routeRemDiv.append(routeRemDivBtn);

                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
                setRouteRemovalCreated(true);
            }
            routeLinesRef.current = state.places;

            handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
        }
    }, [props.MapDetailData]);

    useEffect(() => {
        selectedRowTripType.current = props.TripType;
    }, [props.TripType])

    useEffect( () => {
        if(typeof GlobalMapsObjects.map !== 'undefined') {

            clusterTripsChangeRef.current = [];
            let stopsData = (props.SelectedStopsData.length > 1 ? props.SelectedStopsData : state.places);

            if(routeRemovalCreated)
            {
                // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                // {
                //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                // }
                removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['LEFT_BOTTOM'], index: [2]});
                // const routeRemDiv = document.createElement("div");
                const routeRemDivBtn = createRouteRemovalBtn(GlobalMapsObjects.map, GlobalMapsObjects.maps);
                const routeRemDiv = CommonFunctions.CreateElement("div", {
                    styles: {
                        margin: '10px',
                    },
                    attributes: {
                        id: state.GridName + "_RouteRemDiv"
                    },
                    children: [routeRemDivBtn]
                });

                // routeRemDiv.style.margin = "10px"; 
                // routeRemDiv.id = state.GridName + "_RouteRemDiv";
                // routeRemDiv.append(routeRemDivBtn);

                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
                setRouteRemovalCreated(true);
            }
            routeLinesRef.current = state.places;
            const isClusterSelection = props.SelectedStopsData.some(
                item => item.isClusterGridSelection === true
            );
            let removePlottedVehiclesOnClusterGrid = false;
            if(isClusterSelection == false){
                removePlottedVehiclesOnClusterGrid = true;
            }
            handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, stopsData, props.SelectedStopsData, removePlottedVehiclesOnClusterGrid);
           
        }
       
    }, [props.SelectedStopsData]);

    useEffect( ()=>{
        try 
        {
            if(typeof GlobalMapsObjects.map !== 'undefined'){
                IsCalledFromAffiliateChange.current = true;
                props.handleMapHeight(100);
                clusterTripsChangeRef.current = [];
                reAdjustMapCenter(props.selectedAffiliates, true);
                selectedDate.current = props.selectedDate;
                // GlobalMapsObjects.map.setCenter(mapCenterRef.current);
                let depotSection = document.getElementsByClassName("depotBtn")[0];
                if(showDepotSelected)
                {
                    depotSection.click();
                    depotSection.click();
                }
                
                let zones_elem_btn = document.getElementsByClassName("zones_btn")[0];
                zones_elem_btn.click();
                zones_elem_btn.click();
                RemoveAllMapObjects();
                props.setDetailDataFunc([]);
                
                GlobalMapsObjects.map.setZoom(state.zoom);
                if(MapInfoDivCreated)
                {
                    setMapInfoDivCreated(false);
                    removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['TOP_LEFT'], index: [0]});
                    // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                    // {
                    //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                    // }
                }
                if(routeRemovalCreated)
                {
                    setRouteRemovalCreated(false);
                    removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['LEFT_BOTTOM'], index: [2]});
                    // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                    // {
                    //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                    // }
                }
                if(vehicleTableCreated)
                {
                    setvehicleTableCreated(false);
                    removeMapDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, {location: ['LEFT_TOP'], index: [0]});
                    // if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_TOP].length > 0)
                    // {
                    //     GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_TOP].removeAt(0);
                    // }
                }
            }
        }
        catch (err) {console.log(err);}
        
    }, [props.selectedAffiliates, props.selectedDate]);

    useEffect(()=>{
        try{
            if(GlobalMapsObjects.map !== undefined && props.clusterTripSelected !== null && markers.length > 0)
            {
                for(let i = 0; i < markers.length; i++)
                {
                    if(markers[i].label?.name === props.clusterTripSelected.Number)
                    {
                        markers[i].setAnimation(GlobalMapsObjects.maps.Animation.BOUNCE);
                        stopAnimation(markers[i]);
                    }
                    else
                    {
                        markers[i].setAnimation(null);
                    }
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.clusterTripSelected]);

    useEffect(()=>{
        try{
            if(GlobalMapsObjects.map !== undefined && props.gridType !== 'Dispatch')
            {
                const controlPositionClusterInfo = GlobalMapsObjects.maps.ControlPosition.TOP_LEFT;
                const controlArrayClusterInfo = GlobalMapsObjects.map.controls[controlPositionClusterInfo];
                const controlPosition = GlobalMapsObjects.maps.ControlPosition.RIGHT_TOP;
                const controlArray = GlobalMapsObjects.map.controls[controlPosition];

                if (controlArray.getLength() > 0) {
                    for (let i = 0; i < controlArray.getLength(); i++) {
                        if (controlArray.getAt(i).id.includes("_completedMapDiv")) {
                            controlArray.removeAt(i);
                            break;
                        }
                    }
                }
                if(controlArrayClusterInfo.getLength() > 0) {
                    controlArrayClusterInfo.removeAt(0);
                    setMapInfoDivCreated(false);
                }
            }
        } catch (err) {console.log(err);}
    }, [props.gridType]);

    useEffect(() => {
        if (props.vehData && Array.isArray(props.vehData) && props.vehData.length > 0) {
            vehDataRef.current = props.vehData;
            getNearbyVehicles();
        }
        else
        {
            vehDataRef.current = [];
        }
    }, [props.vehData]);

    function reAdjustMapCenter (newAff, setNewCenter = false) {
        try{
            selectedAff.current = newAff;

            defaultSettings.current = (selectedAff.current && ASCSSettingData[selectedAff.current] ? JSON.parse(ASCSSettingData[selectedAff.current]): null);
            startCenterInfo.current.centerLat =  (defaultSettings.current ? 
                (defaultSettings.current.find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value:39.16552683625823
            );
            startCenterInfo.current.centerLng =  (defaultSettings.current ? 
                (defaultSettings.current.find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value:-77.16834351718929
            );

            mapCenterRef.current = {lat:parseFloat(startCenterInfo.current.centerLat),lng:parseFloat(startCenterInfo.current.centerLng)};
            if(setNewCenter){
                GlobalMapsObjects.map.setCenter(mapCenterRef.current);
            }
        }
        catch(err){console.log(err);}
    }

    function removeMapDiv (mapObj = {}, mapsObj = {}, mapControlInfo = {location: [], index: [], specialCond: ['']}) {
        try{
            const {
                location = [],
                index = [],
                specialCond = ['']
            } = mapControlInfo;

            if(mapControlInfo.location.length > 0) {
                for(let k = 0; k < mapControlInfo.location.length; k++)
                {
                    let position = mapControlInfo.location[k];
                    let actualIndex = mapControlInfo.index[k];
                    let givenCondition = specialCond[k];
                    if(givenCondition === ''){
                        if(mapObj.controls[mapsObj.ControlPosition[position]].length > 0){
                            mapObj.controls[mapsObj.ControlPosition[position]].removeAt(actualIndex);
                        }
                    }
                    else {
                        if(mapObj.controls[mapsObj.ControlPosition[position]].length === (parseInt(givenCondition))){
                            mapObj.controls[mapsObj.ControlPosition[position]].removeAt(actualIndex);
                        }
                    }
                }
            }
        }
        catch(err){console.log(err);}
    }

    function stopAnimation (marker)
    {
        setTimeout(() => {
            marker.setAnimation(null);
        }, 3000);
    }

    const handleAddingNewTrip = async(data, removeVehicle = true)=>{
        try{
            
            additionalTrip.current = [];
            let dict = {};
            let Nodes = [];
            let correctFormatData = (Array.isArray(data) && data.length > 0 ? data[0] : (typeof data === 'object' && !Array.isArray(data)) ? data : []);
            if((Array.isArray(data) && data.length === 1) || (typeof data === 'object' && !Array.isArray(data)))
            {
                const isStandardGrid = (state.GridName !== 'standingOrder' && state.GridName !== 'completedQueue');
                const tripNo = (isStandardGrid ? correctFormatData.ConfirmationNo : correctFormatData["Confirmation #"]);
                const PUAddr = (isStandardGrid ? correctFormatData.PickupAddress : correctFormatData["Pick Location"]);
                const DOAddr = (isStandardGrid ? correctFormatData.Destination : correctFormatData["Dest Location"]);
                const timeString = correctFormatData.PickupDateTime.match(/[\sT]+(\d{1,2}:\d{2}\s?[AP]M)/i)?.[1] || '';
                const timePart = timeString.slice(0, -2);
                const meridian = timeString.slice(-2);
                const schTime = (isStandardGrid ? DateTimeUtils.toMilitaryTime(timePart+" "+meridian).military : '');
                Nodes = [
                    {
                        "TripNo": tripNo,
                        "PUPerson": correctFormatData.PickupPerson,
                        "SchTime": schTime,
                        "Type": "PU",
                        "dLatitude": correctFormatData.PickupLatitude,
                        "dLongitude":correctFormatData.PickupLongitude,
                        "vAddress": PUAddr
                    },
                    {
                        "TripNo": tripNo,
                        "PUPerson": correctFormatData.PickupPerson,
                        "SchTime": '',
                        "Type": "DO",
                        "dLatitude": correctFormatData.DropLatitude,
                        "dLongitude":correctFormatData.DropLongitude,
                        "vAddress": DOAddr
                    }
                ];
                dict.trip = Nodes;
                additionalTrip.current.push(dict);
            }
            else if(Array.isArray(data) && data.length > 1)
            {
                let trips = [];
                for(let y = 0; y < data.length; y++)
                {
                    dict = {};
                    
                    const timeString = data[y].PickupDateTime.match(/[\sT]+(\d{1,2}:\d{2}\s?[AP]M)/i)?.[1] || '';
                    const timePart = timeString.slice(0, -2);
                    const meridian = timeString.slice(-2);
                    let convertedTime = DateTimeUtils.toMilitaryTime(timePart+" "+meridian);
                    const Nodes = [
                        {
                            "TripNo": data[y].ConfirmationNo,
                            "PUPerson": data[y].PickupPerson,
                            "SchTime": convertedTime.military,
                            "Type": "PU",
                            "dLatitude": data[y].PickupLatitude,
                            "dLongitude":data[y].PickupLongitude,
                            "vAddress": data[y].PickupAddress
                        },
                        {
                            "TripNo": data[y].ConfirmationNo,
                            "PUPerson": data[y].PickupPerson,
                            "SchTime": '',
                            "Type": "DO",
                            "dLatitude": data[y].DropLatitude,
                            "dLongitude":data[y].DropLongitude,
                            "vAddress": data[y].Destination
                        }
                    ];
                    trips.push(Nodes);
                }
                dict.trips = trips;
                additionalTrip.current.push(dict);
            }
            
            if(typeof GlobalMapsObjects.map !== 'undefined'){
                handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places, undefined, removeVehicle);
            }
        }
        catch(err){console.log(err);}
    };

    const handleResize = () => {
        setWindowHeight(window.innerHeight);
        // setWindowWidth(window.innerWidth);
    };

    const getInfoWindowString = (place, type, single_vehicle = false) => {
        
        let common_info = "";
        let labelMap = {
            PU: 'Scheduled Pickup',
            DO: 'Scheduled Dropoff',
            Depot: 'Vehicle Info'
        };
        let isDepot = (type === 'Depot');
        let title = isDepot? 'Depot Name' : 'Rider';
        let schTimeVal = isDepot ? place.VehicleInfo : place.SchTime;
        if (type in labelMap) {
            common_info += `
              <div>
                <div class="text-start">
                  <b class="fw-bold">${title}:</b> ${place.PUPerson} <br>
                  <b class="fw-bold">Address:</b> ${place.vAddress} <br>
                  <b class="fw-bold">${labelMap[type]}:</b> ${schTimeVal}
                </div>
              </div>`;
        }
        else {
            if (single_vehicle) {
                if (place.hasOwnProperty("TripRequestStatus")) {
                    let MsgPUorDO = "";
                    if(place.TripRequestStatus == "PICKEDUP"){
                        MsgPUorDO = "Customer picked up, DropOff ETA is not available at the moment.";
                        const EstTimeOD = place?.DOETA || "";
                        const MilesPUorDO = place?.MilesPickOrDrop || "";
                        
                        if (EstTimeOD.trim() !== "") {
                            MsgPUorDO = `Customer picked up & will be dropped at ${EstTimeOD} (${MilesPUorDO} Miles)`;
                        }
                    }
                    else if(place.TripRequestStatus == "ATLOCATION"){
                        MsgPUorDO = "At customer location, DropOff ETA is not available at the moment.";
                        const EstTimeOD = place?.DOETA || "";
                        const MilesPUorDO = place?.MilesPickOrDrop || "";
                        if (EstTimeOD.trim() !== "") {
                            MsgPUorDO = "At customer location & customer will be dropped at " + EstTimeOD + " ( " + MilesPUorDO + " Miles )";
                        }
                    }
                    else if(place.TripRequestStatus == "IRTPU"){
                        MsgPUorDO = "ETA is not available at the moment.";
                        const EstTime = place?.PUETA || "";
                        const MilesPUorDO = place?.MilesPickOrDrop || "";
                        
                        if (EstTime.trim() !== "") {
                            MsgPUorDO = `Driver will reach pickup location at ${EstTime} (${MilesPUorDO} Miles)`;
                        }
                    }

                    common_info += `
                        <div>
                            <div class="text-start">
                                <b class="fw-bold float-left">Vehicle #: </b>
                                    ${place['VEH#']} 
                                <b class="fw-bold float-right" >Driver #:
                                    <b class="fw-light">
                                        ${place['AssignedDriver#']}
                                    </b>
                                </b><br>
                                <b class="fw-bold">State:</b> 
                                    ${(!place.TripRequestStatus ? "N/A" : place.TripRequestStatus)} <br>
                                <b class="fw-bold">VehicleInfo:</b> 
                                    ${(!place.VTYPE? "" : place.VTYPE + " ") + place.VehicleInfo} <br>
                                    <b class="fw-bold">ETA: </b> ${MsgPUorDO} 
                                <!-- <b class="fw-bold">ETA:</b> ${"(" + place.dEstimateDistance + " Miles)"} <br> -->
                            </div>
                        </div>`
                    ;
                } else {
                    common_info += `
                        <div>
                            <div class="text-start">
                            <b class="fw-bold float-left">Vehicle #: </b>
                                ${place.VehNo} 
                            <b class="fw-bold float-right">Driver #:
                                <b class="fw-light">
                                    ${place.DriverNo}
                                </b>
                            </b><br>
                            <b class="fw-bold">State:</b> ${place.STATE} <br>
                            <b class="fw-bold">VehicleInfo:</b> ${place.VehMake + "("+place.VehicleMake+")"} <br>
                            <b class="fw-bold">ETA:</b> ${"("+place.Distance +" Miles)"} <br>
                            </div>
                        </div>`
                    ;
                }

            }
            else {
                // let driver_no = place.AssignedDriver;
                common_info += `
                <div>
                  <div class="text-start">
                    <b class="fw-bold float-left">Vehicle #: </b>
                        ${place.VehNo} 
                    <b class="fw-bold float-right" >Driver #:
                        <b class="fw-light">
                            ${place.DriverNo}
                        </b>
                    </b><br>
                    <b class="fw-bold">State:</b> ${place.STATE} <br>
                    <b class="fw-bold">VehicleInfo:</b> ${place.VehMake + "("+place.VehicleMake+")"} <br>
                    <b class="fw-bold">ETA:</b> ${"("+place.Distance +" Miles)"} <br>
                  </div>
                </div>`;
            };
        }
        return common_info;
    }

    const getMapBounds = (map, maps, places, itemsInArray) => {
        try{
            const bounds = new maps.LatLngBounds();
            if(itemsInArray === "single")
            {
                if(places.length > 0)
                {
                    places.forEach((place) => {
                        if(places[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0)
                        {
                            bounds.extend(new maps.LatLng(
                                parseFloat(place.dLatitude),
                                parseFloat(place.dLongitude),
                            ));
                        }
                        
                        
                    });
                }
            }
            else
            {
                if(places.length > 0)
                {
                    places.forEach((item) => {
                        item.forEach((place)=>{
                            bounds.extend(new maps.LatLng(
                                parseFloat(place.dLatitude),
                                parseFloat(place.dLongitude),
                            ));
                        });
                    });
                }
            }
            return bounds;
        }
        catch(err){console.log(err);}
    };

    const UnmountDispatchActionComponent = () => {
        try{
            setinvokeDispatchComponent(false);
            if(typeof props.GridRefresh === 'function'){
                props.GridRefresh();
            }
            if(document.getElementById(state.GridName+"_vehMapDiv")){
                document.getElementById(state.GridName+"_vehMapDiv").style.display = 'none';
            }
        } catch(err){console.log(err);}
    }
    
    const getMapZones = (map, maps) => {
        let zoneDict = {};
        let zoneColorsDict = {};
        let selectedCompany = document.getElementsByClassName("form-select")[0].value;
        let selectedAffTemp = (selectedAff.current ? parseInt(selectedAff.current) : parseInt(props.selectedAffiliates));
        let counter = 0;
        if(selectedAffTemp === 0)
        {
            for(let i = 0; i < AffiliateData.length; i++){
                if(selectedCompany.indexOf(AffiliateData[i].DTSPID.toString()) > -1){
                    selectedAffTemp = parseInt(AffiliateData[i]["AffiliateID"]);
                }
            }
        }
        for(let s = 0; s < props.zones.length; s++)
        {
            if(props.zones[s].iZVATSPID === selectedAffTemp) //props.selectedAffiliates
            {
                let key = props.zones[s].vName;
                if(key in zoneDict)
                {
                    let zoneLocations = zoneDict[key];
                    let zoneColors = zoneColorsDict[key];
                    zoneColors = [{"vZoneColor": props.zones[s].vZoneColor}];
                    let tempDict = {"lat": parseFloat(props.zones[s].vLat), "lng": parseFloat(props.zones[s].vLong)};
                    zoneLocations.push(tempDict);
                    zoneDict[key] = zoneLocations;
                    zoneColorsDict[key] = zoneColors;
                }
                else
                {
                    let zoneLocations = [];
                    let zoneColors = [];
                    let tempDict = {"lat": parseFloat(props.zones[s].vLat), "lng": parseFloat(props.zones[s].vLong)};
                    zoneLocations.push(tempDict);
                    zoneColors = [{"vZoneColor": props.zones[s].vZoneColor}];
                    zoneDict[key] = zoneLocations;
                    zoneColorsDict[key] = zoneColors;
                }
            }

        }
        for(let i in zoneDict)
        {
            polygons.push(new maps.Polygon({
                paths: zoneDict[i],
                strokeColor: "black",
                strokeOpacity: 0.3,
                strokeWeight: 2,
                fillColor: zoneColorsDict[i][0].vZoneColor,
                fillOpacity: 0.25,
                title: i
            }));
            polygons[counter].setMap(map);
            counter+=1;
        }
    };

    // Function to remove markers with a specific class
    function removeMarkersByClass(className) {
        for (let i = markers.length - 1; i >= 0; i--) {
            const marker = markers[i];
        
            if (marker.className === className) {
                // Remove the marker from the map
                marker.setMap(null);
        
                // Remove the marker from the array
                markers.splice(i, 1);
            }
        }
    }

    const getNearbyVehicles = () => {
        try{
            let vehData = vehDataRef.current;
            vehImage.current = [];
            
            if((state.places && Array.isArray(state.places) && state.places.length > 0) || (addedUnroutedTrip.current.data && addedUnroutedTrip.current.data.length > 0))
            {
                if (vehData.length === 1) {
                    let veh_data = vehData[0];
                    const status = (veh_data.hasOwnProperty("TripRequestStatus") ? 
                        veh_data.TripRequestStatus.toUpperCase() 
                        : 
                        (veh_data.hasOwnProperty("STATE") ? veh_data.STATE.toUpperCase() : "")
                    );
                    const type = (veh_data.AssignedVehType || veh_data.VehicleMake || "").toUpperCase();
                    const isVanLike = (["VAN", "WAGON", "WHEELCHAIR"].includes(type) || type.includes("VAN"));
                    const imageMap = {
                        DISCONNECTED: CabDisconnected,
                        OCCUPIED: isVanLike ? VanOccupied : SedanOccupied,
                        PICKEDUP: isVanLike ? VanOccupied : SedanOccupied,
                        OFFLINE: CabOffline,
                        ACCEPTED: isVanLike ? VanOnline : SedanOnline,
                        ONLINE: isVanLike ? VanOnline : SedanOnline,
                        IRTPU: isVanLike ? VanOnline : SedanOnline,
                        ATLOCATION: isVanLike ? VanOnline : SedanOnline,
                        ASSIGNED: isVanLike ? VanOnline : SedanOnline,
                        NOSHOWREQ: isVanLike ? VanOnline : SedanOnline,
                    };

                    const selectedImg = (imageMap[status] || (isVanLike ? VanOnline : SedanOnline));
                    vehImage.current.push(selectedImg);
                }
                else {

                    for (let vehicle in vehData) {
                        const veh_data = vehData[vehicle];
                        const status = (veh_data.hasOwnProperty("STATE") ? veh_data.STATE.toUpperCase() : "");
                        const type = (veh_data.VehicleMake ? veh_data.VehicleMake : "").toUpperCase();
                        const isVanLike = (["VAN", "WAGON"].includes(type) || type.includes("VAN"));
                        const isLift = (["VPG", "LIFT"]).includes(type);
                        const imageMap = {
                            DISCONNECTED: CabDisconnected,
                            OCCUPIED: isVanLike ? VanOccupied : (isLift ? LiftOccupied : SedanOccupied),
                            PICKEDUP: isVanLike ? VanOccupied : (isLift ? LiftOccupied : SedanOccupied),
                            OFFLINE: CabOffline,
                            ACCEPTED: isVanLike ? VanOnline : SedanOnline,
                            ONLINE: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
                            IRTPU: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
                            ATLOCATION: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline)
                        };

                        const selectedImg = (imageMap[status] || (isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline)));
                        vehImage.current.push(selectedImg);
                    }
                }
            }
            if(typeof GlobalMapsObjects.map !== 'undefined'){
                handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
            }
        }
        catch(err){};
       
    };

    function createElement  (tag, options = {}) {
        try{
            const element = document.createElement(tag);
        
            //set attributes i.e. id, type, title, etc...
            if(options.attributes) {
                Object.entries(options.attributes).forEach(([key, value]) => {
                    element.setAttribute(key, value);
                });
            }

            //Set important CSS styles i.e. font-size, etc...
            if(options.properties && options.properties.length > 0) {
                options.properties.forEach(({style, value}) => {
                    element.style.setProperty(style, value, 'important');
                });
            }
            
            // Set styles...
            if(options.styles){
                Object.assign(element.style, options.styles);
            }
    
            // Add class names...
            if(options.classes){
                element.classList.add(...options.classes);
            }
    
            // Set inner HTML or text
            if(options.text){
                element.textContent = options.text;
            }

            if(options.html){
                element.innerHTML = options.html;
            }

            //Add children...
            if(options.children) {
                options.children.forEach((child) => {
                    element.appendChild(child);
                });
            }

            return element;
        }
        catch(err){console.log(err);}
    }

    const createPopOutMapBtn = () => {
        const controlButton = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: state.commonStyles.margin,
                padding: state.commonStyles.padding,
                textAlign: state.commonStyles.textAlign,
                cssText: "font-size: 24px !important;",
                width: '40px',
                height: '40px',
                backgroundColor: '#fff',
                borderRadius: '3px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            text: "❐",
            classes: ["shadow-sm", "border-0"],
            attributes: {
                title: 'Map Page',
                type: 'button',
                id: state.GridName + "_popOutMaptBtn"
            }
        });

        // Set CSS for the control.
        // controlButton.style.color = "rgb(25,25,25)";
        // controlButton.style.cursor = "pointer";
        // controlButton.style.fontFamily = state.familyFont;
        // controlButton.style.lineHeight = "38px";
        // controlButton.style.margin = "10px 0 22px";
        // controlButton.style.padding = "0 5px";
        // controlButton.style.textAlign = "center";
        // controlButton.textContent = "❐";
        // controlButton.classList.add("shadow-sm", "border-0");
        // controlButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // controlButton.title = "Map Page";
        // controlButton.type = "button";
        // controlButton.id = state.GridName+"_popOutMapBtn";
        // Setup the click event listeners: simply set the map to Chicago.
        controlButton.addEventListener("click", () => {
            let newWindow = window.open('/MapPage', '_blank');
            newWindow.MapDetailData = props.MapDetailData;
            props.handleMapMode(false);
            if(window.getComputedStyle(document.getElementById(state.GridName+'_mapViewBtn')).display === "block" && window.getComputedStyle(document.getElementById(state.GridName+"_container")).display === "block"){
                document.getElementById(state.GridName+'_mapViewBtn').textContent = "Map";
                document.getElementById(state.GridName+'_mapViewBtn').title = "Map View";
                document.getElementById(state.GridName+"_container").className ="col";
            }
        });
        return controlButton;
    }

    const createZoomMapBtn = () => {

        const zoomLockImage = CommonFunctions.CreateElement('img', {
            styles: {
                width: '30px',
                height: '30px',
                margin: 'auto'
            },
            attributes: {
                src: ZoomLockIcon
            }
        });
        
        const zoomButton = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: 0,
                padding: state.commonStyles.padding,
                textAlign: state.commonStyles.textAlign,
                width: '40px',
                height: '40px',
                backgroundColor: '#fff',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            properties: [{style: 'font-size', value: '24px'}],
            classes: ["shadow-sm", "border-0", "d-flex", "justify-content-center"],
            attributes: {
                title: 'Lock Zoom',
                type: 'button',
                id: state.GridName + "_zoomButtonMapBtn"
            },
            children: [zoomLockImage]
        });
        
        // Set CSS for the control.
        // zoomButton.style.color = "rgb(25,25,25)";
        // zoomButton.style.cursor = "pointer";
        // zoomButton.style.fontFamily = state.familyFont;
        // zoomButton.style.lineHeight = "38px";
        // zoomButton.style.margin = "10px 0 22px";
        // zoomButton.style.padding = "0 5px";
        // zoomButton.style.textAlign = "center";
        // // zoomButton.textContent = "Z";
        // zoomButton.classList.add("shadow-sm", "border-0", "d-flex", "justify-content-center");
        // zoomButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // zoomButton.title = "Lock Zoom";
        // zoomButton.type = "button";
        // zoomButton.id = state.GridName+"_zoomButtonMapBtn";
        // Setup the click event listeners: simply set the map to Chicago.
        zoomButton.addEventListener("click", () => {
            if(zoomButton.title === "Lock Zoom")
            {
                zoomButton.title = "Unlock Zoom";
                setZoomOpt({zoomControl: false, draggable: true, scrollWheel: false, disableDoubleClickZoom: true});
            }
            else if(zoomButton.title === "Unlock Zoom")
            {
                zoomButton.title = "Lock Zoom";
                setZoomOpt({zoomControl: true, draggable: true, scrollWheel: true, disableDoubleClickZoom: false});
            }
        });

        return zoomButton;
    }
    const getDateTimeObjectFromTime = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        return new Date(0, 0, 0, hours, minutes);
    }
    const createMapInfoDiv = (map, maps, places, content) =>{
        removeMapDiv(map, maps, {location: ['TOP_LEFT'], index: [0]});
        // if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0) {
        //     map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
        // }
        // const InfoDivCluster = document.createElement("div");
        let estMilesTot = 0;
        let estTimeTot = 0;
        let tripCount = 0;
        let passCount = [];
        let IsSummaryEvaluated = false;
        let differenceInMinutes = null;
        let routeSummary = '';
        let isSchDateGreater = false;

        for(let i = 0; i < places.length; i++)
        {
            estMilesTot+= parseFloat(places[i].EstDistFromPrev);
            estTimeTot+= parseFloat(places[i].EstTimeFromPrev);
            if(places[i].Type.toUpperCase() === "PU" || places[i].Type.toUpperCase() === "DO")
            {
                if(!places[i].bPerformed && !IsSummaryEvaluated){
                        let schDate = getDateTimeObjectFromTime(places[i].SchTime);
                        let forcastedDate = getDateTimeObjectFromTime(places[i].ForcastedTime);
                        isSchDateGreater = schDate > forcastedDate;
                        let differenceInMs = schDate - forcastedDate;
                        differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
                        IsSummaryEvaluated = true;
                }
                tripCount+=1;
                passCount.push(places[i].PUPerson);
            }
        }

        if (differenceInMinutes !== null) {
            let absDifference = Math.abs(differenceInMinutes);

            if (absDifference <= 5 || differenceInMinutes === 0) {
                routeSummary = '| On Time';
            } else if (isSchDateGreater && absDifference > 5) {
                routeSummary = `| Early: ${absDifference} minutes`;
            } else if (!isSchDateGreater && absDifference > 5) {
                routeSummary = `| Late: ${absDifference} minutes`;
            }
        }

        passCount = [...new Set(passCount)];
        tripCount = tripCount/2;
        //cssText: ((windowWidth < 1400 ? 'width: 350px;' : '') + " font-size: small !important; color:white;"),
        
        const label = createElement('label', {
            styles: {
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                // textOverflow: 'ellipsis',
                textWrap: "auto",
                width: '100%'
            },
            text: (content.length === 0
                ? ("Original: Trips: " + tripCount + " | Est. Dist: " + estMilesTot.toFixed(2) +
                    " mi | Est. Time: " + parseInt(estTimeTot) + " mins | Pax Count: " +
                    passCount.length + routeSummary)
                : ("Original: Trips: " + content[0] + " | Est. Dist: " + content[1].toFixed(2) +
                    " mi | Est. Time: " + parseInt(content[2]) + " mins | Pax Count: " +
                    content[3] + routeSummary)
            )
        });

        const InfoDivCluster = createElement('div', {
            styles: {
                color: 'white',
                cursor: 'default',
                fontFamily: state.commonStyles.fontFamily,
                margin: "10px 0 0px",
                padding: state.commonStyles.padding,
                textAlign: state.commonStyles.textAlign,
                width: '70%',
                backgroundColor: 'black',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)',
                overflow: 'hidden'
            },
            classes: [
                "shadow-sm", "border-dark", "user-select-none", "fw-bold",
                "p-1", "mt-3", "mapInfoTextDiv", 'text-start'
            ],
            attributes: {
                id: state.GridName + "_clusterInfoDiv"
            },
            children: [label]
        });
        
        // Set CSS for the control. 
        // InfoDivCluster.style.color = "rgb(25,25,25)";
        // InfoDivCluster.style.cursor = "default";
        // InfoDivCluster.style.fontFamily = state.familyFont;
        // InfoDivCluster.style.margin = "10px 0 0px";
        // InfoDivCluster.style.padding = "0 5px";
        // InfoDivCluster.style.textAlign = "center";
        // InfoDivCluster.textContent = (content.length === 0 ? "Original: Trips: "+tripCount+" | Est. Dist: "+estMilesTot.toFixed(2)+" mi | Est. Time: "+parseInt(estTimeTot)+" mins | Pax Count: "+passCount.length +  routeSummary:
        // "Original: Trips: "+content[0]+" | Est. Dist: "+content[1].toFixed(2)+" mi | Est. Time: "+parseInt(content[2])+" mins | Pax Count: "+content[3] +  routeSummary);
        // InfoDivCluster.classList.add("shadow-sm", "border-dark", "user-select-none", "fw-bold", "p-1", "mt-3", "mapInfoTextDiv");
        // InfoDivCluster.style.cssText = (windowWidth < 1400 ? 'width: 350px;' : '')+" padding:5px; font-size: small !important; text-wrap:balance; color:white; background-color: black; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // InfoDivCluster.id = state.GridName+"_clusterInfoDiv";
        originalInfoRef.current = (content.length === 0 ? 
            ("Original: Trips: " + tripCount + " | Est. Dist: " + 
            estMilesTot.toFixed(2) + " mi | Est. Time: " + parseInt(estTimeTot) + " mins | Pax Count: " + passCount.length)
            : 
            ("Original: Trips: " + content[0] + " | Est. Dist: " + content[1].toFixed(2) + " mi | Est. Time: " + parseInt(content[2]) + " mins | Pax Count: " + content[3])
        );
        return InfoDivCluster;
    }

    const createMapInfoDivPrevious = (map, maps, griddata, content) =>{

        let estMilesTot = 0;
        let estTimeTot = 0;
        let tripCount = 0;
        let passCount = [];

        for(let i = 0; i < griddata.length; i++)
        {
            if(!griddata[i].Type.toUpperCase().includes("IDLE")){
                estMilesTot+= parseFloat(griddata[i].EstDistFromPrev);
                estTimeTot+= parseFloat(griddata[i].EstTimeFromPrev);
            }
            
            if(griddata[i].Type.toUpperCase() === "PU" || griddata[i].Type.toUpperCase() === "DO")
            {
                tripCount+=1;
                passCount.push(griddata[i].PUPerson);
            }
        }
        passCount = [...new Set(passCount)];
        tripCount = tripCount/2;

        const InfoDivOrigInfo = CommonFunctions.CreateElement("p", {
            styles: {
                textWrap: 'balance',
                backgroundColor: '#fff'
            },
            properties: [{style: 'font-size', value: 'small'}],
            classes: ["border-dark", "user-select-none", "fw-bold", "p-1", "m-0", "mapInfoTextDivPrevious", 'text-warning', 'text-start'],
            text: (content.length === 0 ? ("New: Trips: " + tripCount + " | Est. Dist: " + 
                estMilesTot.toFixed(2) + " mi | Est. Time: " + parseInt(estTimeTot) + " mins | Pax Count: " + passCount.length)
                : 
                ("New: Trips: " + content[0] + " | Est. Dist: " + content[1].toFixed(2) + " mi | Est. Time: " + 
                parseInt(content[2]) + " mins | Pax Count: " + content[3])
            )
        });

        const InfoDivClusterPrevious = CommonFunctions.CreateElement('div', {
            styles: {
                cursor: 'default',
                fontFamily: state.commonStyles.fontFamily,
                margin: state.commonStyles.margin,
                padding: state.commonStyles.padding,
                textAlign: state.commonStyles.textAlign,
                textWrap: 'balance',
                backgroundColor: 'black',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            properties: [{style: 'font-size', value: 'small'}],
            classes: ["shadow-sm", "border-dark", "user-select-none", "fw-bold", "p-1", "mt-3", "mapInfoTextDiv", 'text-white', 'text-start'],
            attributes: {
                id: state.GridName + "_clusterInfoDivPrevious"
            },
            text: originalInfoRef.current,
            children: [InfoDivOrigInfo]
        });

        
        
        // Set CSS for the control. 
        // InfoDivClusterPrevious.style.color = "rgb(25,25,25)";
        // InfoDivClusterPrevious.style.cursor = "default";
        // InfoDivClusterPrevious.style.fontFamily = state.commonStyles.fontFamily;
        // InfoDivClusterPrevious.style.margin = "4px0 0 450px";
        // InfoDivClusterPrevious.style.padding = "0 5px";
        // InfoDivClusterPrevious.style.textAlign = "center";
        // InfoDivClusterPrevious.textContent = originalInfoRef.current;
        // InfoDivClusterPrevious.classList.add("shadow-sm", "border-dark", "user-select-none", "fw-bold", "p-1", "mt-3", "mapInfoTextDiv");
        // InfoDivClusterPrevious.style.cssText = "font-size: small !important; text-wrap:balance; width:320px; color:green; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // InfoDivClusterPrevious.id = state.GridName+"_clusterInfoDivPrevious";

        // InfoDivOrigInfo.classList.add("border-dark", "user-select-none", "fw-bold", "p-1", "m-0", "mapInfoTextDivPrevious");
        // InfoDivOrigInfo.style.cssText = "font-size: small !important; text-wrap:balance; color:#685c5c; background-color: #fff;";
        // InfoDivOrigInfo.textContent = (content.length === 0 ? "New: Trips: "+tripCount+" | Est. Dist: "+estMilesTot.toFixed(2)+" mi | Est. Time: "+parseInt(estTimeTot)+" mins | Pax Count: "+passCount.length: 
        //     "New: Trips: "+content[0]+" | Est. Dist: "+content[1].toFixed(2)+" mi | Est. Time: "+parseInt(content[2])+" mins | Pax Count: "+content[3] );
        // InfoDivClusterPrevious.appendChild(InfoDivOrigInfo);

        return InfoDivClusterPrevious;
    }

    const createRouteRemovalBtn = (map, maps) =>{
        // const routeRemovalBtn = document.createElement("button");
        // const routeRemovalImage = document.createElement("img");
        const routeRemovalImage = CommonFunctions.CreateElement('img', {
            styles: {
                margin: 'auto',
                width: '30px',
                height: '35px',
            },
            attributes:{
                src: RouteRemovalIcon
            }
        });

        const routeRemovalBtn = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: 0,
                textAlign: state.commonStyles.textAlign,
                width: '40px',
                height: '40px',
                textWrap: 'balance',
                backgroundColor: '#fff',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            properties: [{style: 'font-size', value: '24px'}],
            classes: ["shadow-sm", "border-0", "d-flex", "justify-content-center"],
            attributes:{
                type: 'button',
                title: 'Hide Routes',
                id: state.GridName+"_routeRemovalMapBtn"
            },
            children: [routeRemovalImage]
        });

        // routeRemovalImage.src = RouteRemovalIcon;
        // routeRemovalImage.style = "width:30px;height:35px; margin:auto";
        
        // Set CSS for the control.
        // routeRemovalBtn.style.color = "rgb(25,25,25)";
        // routeRemovalBtn.style.cursor = "pointer";
        // routeRemovalBtn.style.fontFamily = state.familyFont;
        // routeRemovalBtn.style.lineHeight = "38px";
        // routeRemovalBtn.style.margin = "10px 0 22px";
        // routeRemovalBtn.style.padding = "0 5px";
        // routeRemovalBtn.style.textAlign = "center";
        // routeRemovalBtn.classList.add("shadow-sm", "border-0", "d-flex", "justify-content-center");
        // routeRemovalBtn.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // routeRemovalBtn.title = "Hide Routes";
        // routeRemovalBtn.type = "button";
        // routeRemovalBtn.id = state.GridName+"_routeRemovalMapBtn";
        routeRemovalBtn.addEventListener("click", async() => {
            if(routeRemovalBtn.title === "Hide Routes")
            {
                routeRemovalBtn.title = "Show Routes";
                for(let i = 0; i < PolyPaths.length; i++) {
                    PolyPaths[i].setMap(null);
                }

            }
            else if(routeRemovalBtn.title === "Show Routes")
            {
                let newRouteArray = [];
                routeRemovalBtn.title = "Hide Routes"; 
                if(clusterTripsChangeRef.current.length > 0)
                {
                    getStraightPolylines(clusterTripsChangeRef.current, GlobalMapsObjects.map, GlobalMapsObjects.maps);
                    if(singleRoutePolylineRef.current !== undefined && singleRoutePolylineRef.current.length > 0 && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current.forEach(item=>{
                            item.setMap(map);
                            PolyPaths.push(item);
                        });
                        setPolyPaths(PolyPaths);
                    }
                }
                else
                {
                    routeLinesRef.current.forEach((place)=>{
                        if(place.Type === "PU")
                        {
                            newRouteArray.push({trip:"P", latLng: new maps.LatLng(parseFloat(place.dLatitude),parseFloat(place.dLongitude)), time: place.SchTime });
                        }
                        else if(place.Type === "DO")
                        {
                            newRouteArray.push({trip:"D", latLng: new maps.LatLng(parseFloat(place.dLatitude),parseFloat(place.dLongitude)), time: place.SchTime });
                        }
                    });
                    if(singleRoutePolylineRef.current !== undefined && singleRoutePolylineRef.current.length > 0 && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current.forEach(item=>{
                            item.setMap(map);
                            PolyPaths.push(item);
                        });
                        setPolyPaths(PolyPaths);
                    }
                    getStraightPolylines(newRouteArray, map, maps);
                } 
            }
        });

        // routeRemovalBtn.appendChild(routeRemovalImage);

        return routeRemovalBtn;
    }

    const createDepotBtn = (map, maps, places) =>{
        // const depotButton = document.createElement("button");
        // const depotImage = document.createElement("img");
        const depotImage = CommonFunctions.CreateElement('img', {
            styles: {
                margin: 'auto',
                width: '30px',
                height: '35px',
            },
            attributes:{
                src: DepotIcon
            }
        });
        // depotImage.src = DepotIcon;
        // depotImage.style = "width:30px; height:35px; margin:auto";
        const depotButton = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: 0,
                textAlign: state.commonStyles.textAlign,
                width: '40px',
                height: '40px',
                textWrap: 'balance',
                backgroundColor: '#fff',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            properties: [{style: 'font-size', value: '24px'}],
            classes: ["shadow-sm", "border-0", "depotBtn", "d-flex", "justify-content-center"],
            attributes:{
                type: 'button',
                title: 'Show Depot',
                id: state.GridName+"_depotButtonMapBtn"
            },
            children: [depotImage]
        });

        // Set CSS for the control.
        // depotButton.style.color = "rgb(25,25,25)";
        // depotButton.style.cursor = "pointer";
        // depotButton.style.fontFamily = state.commonStyles.fontFamily;
        // depotButton.style.lineHeight = "38px";
        // depotButton.style.margin = "10px 0 22px";
        // depotButton.style.padding = "0 5px";
        // depotButton.style.textAlign = "center";
        // depotButton.classList.add("shadow-sm", "border-0", "depotBtn", "d-flex", "justify-content-center");
        // depotButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // depotButton.title = "Show Depot";
        // depotButton.type = "button";
        // depotButton.id = state.GridName+"_depotButtonMapBtn";

        depotButton.addEventListener("click", async() => {
            if(depotButton.title === "Show Depot")
            {
                depotButton.title = "Hide Depot";
                setShowDepotSelected(true);
                handleAddDepot(map, maps);
            }
            else if(depotButton.title === "Hide Depot")
            {
                depotButton.title = "Show Depot";
                //removing depot points
                setShowDepotSelected(false);
                for(let i = 0; i < depotMarkers.length; i++) {
                    depotMarkers[i].setMap(null);
                }
                for(let i = 0; i < depotInfo.length; i++) {
                    depotInfo[i].setMap(null);
                }
            }
        });
        // depotButton.appendChild(depotImage); 
        return depotButton;
    }

    const createVehicleBtn = (map, maps, markersFound) => {
        // const vehicleButton = document.createElement("button");
        // const vehicleImage = document.createElement("img");
        const hasDispatchedVehicle = markersFound.some(marker => marker.className === 'dispatched_Vehicle');

        const vehicleImage = CommonFunctions.CreateElement('img', {
            styles: {
                margin: 'auto',
                width: '30px',
                height: '35px',
            },
            attributes:{
                src: (hasDispatchedVehicle ? VanOnline : VehicleNotAssigned)
            }
        });

        const vehicleButton = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: 0,
                textAlign: state.commonStyles.textAlign,
                width: '40px',
                height: '40px',
                textWrap: 'balance',
                backgroundColor: '#fff',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            properties: [{style: 'font-size', value: '24px'}],
            classes: ["shadow-sm", "border-0", "depotBtn", "d-flex", "justify-content-center"],
            attributes:{
                type: 'button',
                title: (hasDispatchedVehicle ? "Show Vehicle" : "No Vehicle Assigned"),
                id: state.GridName+"_vehicleButtonMapBtn"
            },
            children: [vehicleImage]
        });
    
        // if (hasDispatchedVehicle) {
        //     vehicleImage.src = VanOnline;
        //     vehicleButton.title = "Show Vehicle";
        // }    
        // else 
        // {
        //     vehicleImage.src = VehicleNotAssigned;
        //     vehicleButton.title = "No Vehicle Assigned";
            
        // }
        // vehicleImage.style = "width:30px; height:35px; margin:auto";

        // Set CSS for the control.
        
        // vehicleButton.style.color = "rgb(25,25,25)";
        // vehicleButton.style.cursor = "pointer";
        // vehicleButton.style.fontFamily = "Roboto,Arial,sans-serif";
        // vehicleButton.style.lineHeight = "38px";
        // vehicleButton.style.margin = "10px 0 22px";
        // vehicleButton.style.padding = "0 5px";
        // vehicleButton.style.textAlign = "center";
        // vehicleButton.classList.add("shadow-sm", "border-0", "depotBtn", "d-flex", "justify-content-center");
        // vehicleButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // vehicleButton.type = "button";
        // vehicleButton.id = state.GridName+"_vehicleButtonMapBtn";
        vehicleButton.addEventListener("click", async() => {
            if (vehicleButton.title === "Show Vehicle") {
                const vehicleMarkers = markersFound.filter(
                    (marker) => marker.className === "dispatched_Vehicle"
                );
        
                if (vehicleMarkers.length > 0) {
                    const bounds = new maps.LatLngBounds();
                    const mapBounds = map.getBounds();
                    let anyOutside = false;
        
                    vehicleMarkers.forEach((marker) => {
                        const markerPos = marker.getPosition();
                        if (markerPos && markerPos.lat()) {
                            marker.setAnimation(maps.Animation.BOUNCE);
                            stopAnimation(marker); // Optional
                            bounds.extend(markerPos);
        
                            if (!mapBounds.contains(markerPos)) {
                                anyOutside = true;
                            }
                        }
                    });
        
                    // If only one, and it's outside the bounds, center it
                    if (vehicleMarkers.length === 1) {
                        const markerPos = vehicleMarkers[0].getPosition();
                        if (!mapBounds.contains(markerPos)) {
                            map.setCenter(markerPos);
                            map.setZoom(16);
                        }
                    }
        
                    // If more than one and any are outside, fit bounds
                    if (vehicleMarkers.length > 1 && anyOutside) {
                        map.fitBounds(bounds);
                    }
                }
            }
           
        });

        // vehicleButton.appendChild(vehicleImage); 

        return vehicleButton;
    }

    function removeTripMarkersRoutes (map, maps) {
        try{
            props.setNullifyActivated(true);
            setRouteRemovalCreated(false);
            props.handleMapHeight(100);
            props.selectedTripInfoToRefreshGrid.current= null
            props.DropDownRouteValue.current= null
            removeMapDiv(map, maps, {location: ['LEFT_BOTTOM', 'TOP_LEFT', 'LEFT_TOP'], index: [2, 0, 0], specialCond: [3, '', '']});
            // if(map.controls[maps.ControlPosition.LEFT_BOTTOM].length === 3)
            // {
            //     map.controls[maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
            // }
            setMapInfoDivCreated(false);
            // if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
            // {
            //     map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
            // }
            setvehicleTableCreated(false);
            // if(map.controls[maps.ControlPosition.LEFT_TOP].length > 0)
            // {
            //     map.controls[maps.ControlPosition.LEFT_TOP].removeAt(0);
            // }
            keepZoneRef.current = true;
            RemoveAllMapObjects();
            props.setDetailDataFunc([]);

            // startCenterLat = defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")?.value : 39.16552683625823;
            // startCenterLng = defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")?.value : -77.16834351718929;
            // mapCenterRef.current = {lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)};
            if(!mapCenterRef.current.lat || mapCenterRef.current.lat === 0) {
                mapCenterRef.current = {lat:parseFloat(startCenterInfo.current.centerLat),lng:parseFloat(startCenterInfo.current.centerLng)};
            }
            
            if (!props.isFromDoubleClick) {
                // Retrieve from persisted storage if available
                // startCenterLat = PersistStorage.retrieve("lastUserMapCenterLat", false) ?? null;
                // startCenterLng = PersistStorage.retrieve("lastUserMapCenterLong", false) ?? null;
                state.zoom = PersistStorage.retrieve("lastUserZoomLevel", false);

                // if(startCenterLat || startCenterLng){
                //     // mapCenterRef.current = {lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)};
                // }
                
            } 
            map.setCenter(mapCenterRef.current);
            map.setZoom(state.zoom);
        }
        catch(err){console.log(err);}
    }

    const createMarkerRemovalBtn = (map, maps) =>{
        const nullifyImage = CommonFunctions.CreateElement('img', {
            styles: {
                margin: 'auto',
                width: '30px',
                height: '32px',
            },
            attributes:{
                src: nullifyIcon
            }
        });

        const nullifyButton = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: 0,
                textAlign: state.commonStyles.textAlign,
                width: '40px',
                height: '40px',
                backgroundColor: '#fff',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)'
            },
            properties: [{style: 'font-size', value: '24px'}],
            classes: ["shadow-sm", "border-0", "d-flex", "justify-content-center"],
            attributes:{
                type: 'button',
                title: "Remove Trips From Map",
                id: state.GridName+"_nullifyButtonMapBtn"
            },
            children: [nullifyImage]
        });
        // const nullifyButton = document.createElement("button");
        // const nullifyImage = document.createElement("img");

        // nullifyImage.src = nullifyIcon;
        // nullifyImage.style = "width:30px; height:32px; margin:auto";

        // Set CSS for the control.
        // nullifyButton.style.color = "rgb(25,25,25)";
        // nullifyButton.style.cursor = "pointer";
        // nullifyButton.style.fontFamily = "Roboto,Arial,sans-serif";
        // nullifyButton.style.lineHeight = "38px";
        // nullifyButton.style.margin = "10px 0 22px";
        // nullifyButton.style.padding = "0 5px";
        // nullifyButton.style.textAlign = "center";
        // nullifyButton.classList.add("shadow-sm", "border-0", "d-flex", "justify-content-center");
        // nullifyButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // nullifyButton.title = "Remove Trips From Map";
        // nullifyButton.type = "button";
        // nullifyButton.id = state.GridName+"_nullifyButtonMapBtn";
        nullifyButton.addEventListener("click", ()=>{removeTripMarkersRoutes(map, maps);});

        // nullifyButton.appendChild(nullifyImage);

        return nullifyButton;
    }

    const createZoneMapBtn = (map, maps) => {

        const zoneImage = CommonFunctions.CreateElement('img', {
            styles: {
                margin: 'auto',
                width: '30px',
                height: '35px',
            },
            attributes:{
                src: ZoneIcon
            }
        });

        const zoneButton = CommonFunctions.CreateElement('button', {
            styles: {
                color: state.commonStyles.color,
                cursor: 'pointer',
                fontFamily: state.commonStyles.fontFamily,
                lineHeight: state.commonStyles.lineHeight,
                margin: 0,
                textAlign: state.commonStyles.textAlign,
                width: '40px',
                height: '40px',
                backgroundColor: '#fff',
                borderRadius: '0px',
                boxShadow: '0 2px 6px rgba(0, 0, 0, .3)'
            },
            properties: [{style: 'font-size', value: '24px'}],
            classes: ["shadow-sm", "border-0", "zones_btn", "d-flex", "justify-content-center"],
            attributes:{
                type: 'button',
                title: "Show Zones",
                id: state.GridName+"_zoomButtonMapBtn"
            },
            children: [zoneImage]
        });

        // const zoneButton = document.createElement("button");
        // const zoneImage = document.createElement("img");

        // zoneImage.src = ZoneIcon;
        // zoneImage.style = "width:30px;height:35px";

        // Set CSS for the control.
        // zoneButton.style.color = "rgb(25,25,25)";
        // zoneButton.style.cursor = "pointer";
        // zoneButton.style.fontFamily = "Roboto,Arial,sans-serif";
        // zoneButton.style.lineHeight = "38px";
        // zoneButton.style.margin = "10px 0 22px";
        // zoneButton.style.padding = "0 5px";
        // zoneButton.style.textAlign = "center";
        // zoneButton.classList.add("shadow-sm", "border-0", "zones_btn", "d-flex", "justify-content-center");
        // zoneButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        // zoneButton.title = "Show Zones";
        // zoneButton.type = "button";
        // zoneButton.id = state.GridName+"_zoomButtonMapBtn";

        // Setup the click event listeners: simply set the map to Chicago.
        zoneButton.addEventListener("click", () => {
            
            if(zoneButton.title === "Hide Zones")
            {
                zoneButton.title = "Show Zones";
                for(let i = 0; i < polygons.length; i++) {
                    polygons[i].setMap(null);
                }
                polygons = [];
            }
            else if(zoneButton.title === "Show Zones")
            {
                zoneButton.title = "Hide Zones";
                getMapZones(map, maps);
            }
            
            
        });
        // zoneButton.appendChild(zoneImage);

        return zoneButton;
    };

    const createVehTreeTable = (map, maps) => {

        // const tableDiv = CommonFunctions.CreateElement('table', {
        //     styles: {
        //         color: state.commonStyles.color,
        //         cursor: 'pointer',
        //         fontFamily: state.commonStyles.fontFamily,
        //         lineHeight: state.commonStyles.lineHeight,
        //         textAlign: state.commonStyles.textAlign,
        //         width: '40px',
        //         height: '40px',
        //         backgroundColor: '#fff',
        //         borderRadius: '0px',
        //         boxShadow: '0 2px 6px rgba(0, 0, 0, .3)'
        //     },
        //     properties: [{style: 'font-size', value: '24px'}],
        //     classes: ["shadow-sm", "border-0"],
        //     attributes:{
        //         id: state.GridName+"_vehTableTree"
        //     }
        // });

        const tableDiv = document.createElement("table");

        // Set CSS for the control.
        tableDiv.style.color = "rgb(25,25,25)";
        tableDiv.style.cursor = "pointer";
        tableDiv.style.fontFamily = "Roboto,Arial,sans-serif";
        tableDiv.style.lineHeight = "38px";
        tableDiv.style.margin = "10px 0 22px";
        tableDiv.style.padding = "0 5px";
        tableDiv.style.textAlign = "center";
        tableDiv.classList.add("shadow-sm", "border-0");
        tableDiv.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 0px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        tableDiv.id = state.GridName+"_vehTableTree";

        return tableDiv;
    };

    const handleAddDepot = async(map, maps)=>{
        try{
            let params = {
                "dtServiceDate": selectedDate.current,
                "vAffID": selectedAff.current, //"12/06/2023",
                "iSettingID": "-1",
            };
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllDepots", "post", { "Content-Type": "application/json" }, params,  null);
            let result = response.data;
            if(result.length > 0)
            {
                try{
                    for(let y = 0; y < result.length; y++)
                    {
                        depotMarkers.push(new maps.Marker({
                            position: {
                            lat: parseFloat(result[y].DepotLatitude),
                            lng: parseFloat(result[y].DepotLongitude),
                            },
                            map,
                            icon: "https://maps.gstatic.com/mapfiles/ms2/micons/homegardenbusiness.png",
                        }));
                        depotInfo.push(new maps.InfoWindow({
                            content: `<div>
                            <div class="text-start">
                            <b class="fw-bold float-left">Depot Name: </b>${result[y].DepotName} <br>
                            <b class="fw-bold">Address: </b> ${result[y].DepotAddress} <br></div>
                        </div>`,
                        }));
                        // bounds.extend(new maps.LatLng(
                        //     parseFloat(result[y].DepotLatitude),
                        //     parseFloat(result[y].DepotLongitude),
                        // ));
                    }
                    depotMarkers.forEach((marker, i)=>{
                        marker.addListener('mouseover', () => {
                            depotInfo[i].open(map, marker);
                        });
                        marker.addListener("mouseout", () => {
                            depotInfo[i].close();
                        });
                    });
                    setDepotMarkers(depotMarkers);
                    setDepotInfo(depotInfo);
                    
                }
                catch(err){console.log(err);}
            }
            else
            {
                console.log("no depot given");
            }
        }
        catch(err){console.log(err);}
    }

    function RemoveShowCompletedCheckBoxFromMap(map, maps){
        try {
            if(MapShowCompletedRef.current != undefined){
                let titleOfbutton = MapShowCompletedRef.current?.querySelector('#tabulator_ShowCompletedButtonMap').title;
                if(titleOfbutton != undefined){
                    if(props.IsCheckCompletedTrips){
                        setIsShowCompleted(true);
                        props.setCheckCompletedTrips(true);
                    }
                    else{
                        setIsShowCompleted(false);
                        props.setCheckCompletedTrips(false);
                    }
                }
                const index = map.controls[maps.ControlPosition.RIGHT_TOP].getArray().indexOf(MapShowCompletedRef.current);
                if (index > -1) {
                  map.controls[maps.ControlPosition.RIGHT_TOP].removeAt(index);
                }
            }    
        } catch (error) {
            
        }
    }
    
    function SetSelectedAff(){
        try {
            if(selectedAff.current == null || selectedAff.current == undefined){
                let savedAffiliate = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
                if(savedAffiliate){
                    selectedAff.current = savedAffiliate;
                }
            }
        } catch (error) {
            
        }
    }

    const handleApiLoaded = (map, maps, places, selectedSingleRow = undefined, removeVehicle = true) => {
    try{
        SetSelectedAff();
            
            keepZoneRef.current = false;
            if(props.sidebarStatus)
            {
                let mapContainer = document.getElementById(props.options.GridName +'_mapContainer');
                let clusterContainer = document.getElementById("clusterTableGrid_container");
                let gridContainer = document.getElementById(props.options.GridName+"_container");
                if(gridContainer && !gridContainer.classList.contains('gridOpenMapStyle')){gridContainer.classList.add('gridOpenMapStyle');}
                if(mapContainer && !state.mapClass.includes("mapOpenStyle")){mapContainer.classList.add("mapOpenStyle");}
                if(clusterContainer && !clusterContainer.classList.contains("mapOpenStyle")){clusterContainer.classList.add("mapOpenStyle");}
            }
            RemoveAllMapObjects(selectedSingleRow, removeVehicle);
            let oms = new OverlappingMarkerSpiderfier(map, {
                markersWontMove: true,
                markersWontHide: true,
                spiderfiedShadowColor: false,
                nudgeStackedMarkers: false,
            });
            let newPathArray = [];
            if(state.mapheight === "auto") { 
                let newHeight = windowHeight - state.heightoffset;
                
                if(document.getElementById("clusterTableGrid_container") && 
                    window.getComputedStyle(document.getElementById("clusterTableGrid_container")).display === "block" && 
                    document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toLowerCase().includes("hide")
                )
                {
                    setTimeout(() => {
                        try{
                            let offsetHeight = (document.getElementById("clusterTableGrid_container") ? document.getElementById("clusterTableGrid_container").offsetHeight : 0);
                            newHeight = newHeight - offsetHeight;
                        
                            setMapDivHeight({height:newHeight});
                        }
                        catch(err){console.log(err);}
                        
                    }, 500);
                }
                else
                {
                    setMapDivHeight({height:newHeight});
                }
                // setMapDivHeight({height: newHeight+"px"});
            }
            else
            {
                setMapDivHeight({height: state.mapheight})
            }

        
            if(MapZoneCreated === false)
            {
                try {
                    const rightTopControls = map.controls[maps.ControlPosition.RIGHT_TOP];
                    for (let i = rightTopControls.length - 1; i >= 0; i--) {
                        const ctrl = rightTopControls.getAt(i);
                        if (ctrl && ctrl.id && ctrl.id.includes('_zoneMapDiv')) {
                            rightTopControls.removeAt(i);
                        }
                    }
                } catch (error) {
                    
                }

                const ZoneDiv = CommonFunctions.CreateElement('div', {
                    styles: {
                        margin: '10px'
                    },
                    attributes:{
                        id: state.GridName+"_zoneMapDiv"
                    }
                });

                // const ZoneDiv = document.createElement("div");

                // Create the control.
                const ZoneOption = createZoneMapBtn(map, maps);

                // ZoneDiv.id = state.GridName +"_zoneMapDiv";
                // ZoneDiv.style.margin = "10px";

                // Append the control to the DIV.
                ZoneDiv.appendChild(ZoneOption);
                map.controls[maps.ControlPosition.RIGHT_TOP].push(ZoneDiv);
                setMapZoneCreated(true);
            }

            if(MapInfoDivCreated === false && places && places.length > 0 
                && places[0].Route !== "" && places[0].Route !== undefined)
            {
                if(MapPreviousInfoDivCreated)
                {
                    setMapPreviousInfoDivCreated(false);
                    removeMapDiv(map, maps, {location: ['TOP_LEFT'], index: [0]});
                    // if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                    // {
                    //     map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                    // }
                }
                // Create the control.
                const infoDiv = createMapInfoDiv(map, maps, places, []);
                map.controls[maps.ControlPosition.TOP_LEFT].push(infoDiv);
                setMapInfoDivCreated(true);
            }

            if(MapZoomCreated === false)
            {
                // Create the control.
                const ZoomOption = createZoomMapBtn();

                const ZoomDiv = CommonFunctions.CreateElement('div', {
                    styles: {
                        margin: '10px'
                    },
                    attributes:{
                        id: state.GridName+"_zoomMapDiv"
                    },
                    children: [ZoomOption]
                });
                // const ZoomDiv = document.createElement("div");
                
                // ZoomDiv.id = state.GridName +"_zoomMapDiv";
                // ZoomDiv.style.margin = "10px";

                // Append the control to the DIV.
                // ZoomDiv.appendChild(ZoomOption);

                map.controls[maps.ControlPosition.RIGHT_TOP].push(ZoomDiv);
                setMapZoomCreated(true);
            }
            if((state.GridName !== 'standingOrder' && state.GridName !== 'completedQueue'))
            {
                ShowCompletedTripsMapButton(map, maps);
            }
            if(MapDepotCreated === false)
            {
                try {
                    const leftBottomControls = map.controls[maps.ControlPosition.LEFT_BOTTOM];
                    for (let i = leftBottomControls.length - 1; i >= 0; i--) {
                        const ctrl = leftBottomControls.getAt(i);
                        if (ctrl && ctrl.id && ctrl.id.includes('_deptMapDiv')) {
                            leftBottomControls.removeAt(i);
                        }
                    }
                } catch (error) {
                    
                }

                const deptOption = createDepotBtn(map, maps);
                const deptDiv = CommonFunctions.CreateElement('div', {
                    styles: {
                        margin: '10px'
                    },
                    attributes:{
                        id: state.GridName+"_deptMapDiv"
                    },
                    children: [deptOption]
                });
                // const deptDiv = document.createElement("div");
                
                // deptDiv.id = state.GridName + "_deptMapDiv";
                // deptDiv.style.margin = "10px";

                // deptDiv.appendChild(deptOption);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(deptDiv);
                setMapDepotCreated(true);
            }

            if(MapMarkerRemovalCreated === false)
            {
                const nullifyOption = createMarkerRemovalBtn(map, maps);

                const nullifyDiv = CommonFunctions.CreateElement('div', {
                    styles: {
                        margin: '10px'
                    },
                    attributes:{
                        id: state.GridName+"_nullifyMapDiv"
                    },
                    children: [nullifyOption]
                });
                // const nullifyDiv = document.createElement("div");
                
                // nullifyDiv.id = state.GridName + "_nullifyMapDiv";
                // nullifyDiv.style.margin = "10px";

                // nullifyDiv.appendChild(nullifyOption);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(nullifyDiv);
                setMapMarkerRemovalCreated(true);
            }   

            const controls = map.controls[maps.ControlPosition.LEFT_BOTTOM];
            for (let i = controls.length - 1; i >= 0; i--) {
                const ctrl = controls.getAt(i);
                if (ctrl && ctrl.id && ctrl.id.toLowerCase().includes('_routeremdiv')) {
                    controls.removeAt(i);
                }
                setRouteRemovalCreated(false);
            }

            let routeRemovalBtnExists = 
                (map.controls[maps.ControlPosition.LEFT_BOTTOM].length > 0 ? 
                    map.controls[maps.ControlPosition.LEFT_BOTTOM].Eg.filter(item=> item.id.toLowerCase().trim().includes('_routeremdiv')) : []);
            if(/*!routeRemovalCreated && routeRemovalBtnExists.length === 0 && places &&*/ places.length > 0)
            {
                const routeRemDivBtn = createRouteRemovalBtn(map, maps);
                const routeRemDiv = CommonFunctions.CreateElement('div', {
                    styles: {
                        margin: '10px'
                    },
                    attributes:{
                        id: state.GridName+"_RouteRemDiv"
                    },
                    children: [routeRemDivBtn]
                });
                // const routeRemDiv = document.createElement("div");
                
                
                // routeRemDiv.style.margin = "10px"; 
                // routeRemDiv.id = state.GridName + "_RouteRemDiv";
                // routeRemDiv.append(routeRemDivBtn);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
                setRouteRemovalCreated(true);
            }

            const existingVehDiv = document.getElementById(state.GridName + "_vehMapDiv");
            if (existingVehDiv) {
                existingVehDiv.remove();
                setvehicleTableCreated(false);
            }

            /// Vehicle Dispatch Section
            if(props.vehData && props.vehData !== "" && (Array.isArray(props.vehData) 
                && props.vehData.length > 0) 
                && JSON.stringify(props.vehData) !== JSON.stringify(vehicleTableData) 
                && props.TripType?.current == "Routed-0")
            {
                let vehicleTableCreatedFlag = vehicleTableCreated;
                if(props.vehData.length === 1 && props.vehData[0].iAssignedVehicleId)
                {
                    if(vehicleTableCreatedFlag) //&& map.controls[maps.ControlPosition.LEFT_TOP].length > 0
                    {
                        removeMapDiv(map, maps, {location: ['LEFT_TOP'], index: [0]});
                        vehicleTableCreatedFlag = false;
                        setvehicleTableCreated(false);
                    }
                }
                else
                {
                    setVehicleTableData(props.vehData);

                    const existingVehDiv = document.getElementById(state.GridName + "_vehMapDiv");
                    if (existingVehDiv) {
                        existingVehDiv.remove();
                    }
                    // Create the control.
                    const VehOption = createVehTreeTable();

                    const vehDiv = CommonFunctions.CreateElement('div', {
                        styles: {
                            margin: '10px'
                        },
                        attributes:{
                            id: state.GridName+"_vehMapDiv"
                        },
                        children: [VehOption]
                    });
                    // const vehDiv = document.createElement("div");

                    
                    // vehDiv.id = state.GridName +"_vehMapDiv";
                    // vehDiv.style.margin = "10px";

                    if(vehicleTableCreatedFlag)
                    {
                        removeMapDiv(map, maps, {location: ['LEFT_TOP'], index: [0]});
                        vehicleTableCreatedFlag = false;
                        setvehicleTableCreated(false);
                    }
                    let vehInfoArr = [];
                    let vehDict = {};
                    let CloseVehCount = 0;
                    for(let f = 0; f < props.vehData.length; f++)
                    {
                        vehDict = {};
                        if(props.vehData[f].STATE !== "OFFLINE" && props.vehData[f].STATE !== "DISCONNECTED" && parseFloat(props.vehData[f].Distance) < 20)
                        {
                            CloseVehCount += 1;
                            vehDict["vehNo"] = props.vehData[f].VehNo;
                            vehDict["Dist"] = props.vehData[f].Distance;
                            vehDict["MapVehicleID"] = props.vehData[f].iVehicleID;
                            vehDict["MapDriverID"] = props.vehData[f].iDriverID;
                            vehInfoArr.push(vehDict);
                        }
                    }
                    
                    if(vehInfoArr.length > 0)
                    {
                        const thead = document.createElement("thead");
                        thead.innerHTML = `
                            <tr style="border-bottom:1px solid black; font-size:10px; text-align:center;">
                                <th style="border-right:1px solid black;">Veh#(${CloseVehCount})</th>
                                <th style="border-right:1px solid black;">Dist.</th>
                                <th>Action</th>
                            </tr>
                        `;
                        const tbody = document.createElement("tbody");
                        tbody.style.border = "border:1px solid black";
                        tbody.style.fontSize = "13px";
                        vehInfoArr.sort((a, b) => a.Dist - b.Dist);
                        
                        vehInfoArr.forEach((veh) => {
                            const row = document.createElement("tr");
                            row.style = "border:1px solid black; font-size:10px; text-align:center;";
                        
                            row.innerHTML = `
                            <td style="border-right:1px solid black;">${veh.vehNo}</td>
                            <td style="border-right:1px solid black;">${veh.Dist}</td>
                            <td>
                                <button type="button" title="Dispatch Vehicle #${veh.vehNo}" id="${veh.vehNo}_vehicleBtn">Dispatch</button>
                            </td>
                            `;
                        
                            tbody.appendChild(row);
                        });
                        
                        if(VehOption){
                            VehOption.appendChild(thead);
                            VehOption.appendChild(tbody);
                            vehDiv.appendChild(VehOption);
                        }
                        if(!vehicleTableCreatedFlag)
                        {
                            map.controls[maps.ControlPosition.LEFT_TOP].push(vehDiv);
                        }
                        if(VehOption)
                        {
                            const buttons = document.querySelectorAll('[id*="_vehTableTree"]');
                            buttons.forEach((button) => {
                                button.addEventListener("click", (e) => {
                                    let vehNo = parseInt(e.target.id.split("_")[0]);
                                    if(vehNo > 0)
                                    {
                                        document.getElementById(e.target.id).innerHTML = "<span role='status' aria-hidden='true' class='spinner-border spinner-border-sm'></span>";
                                        for (let i = 0; i < props.vehData.length; i++) {
                                            if (props.vehData[i].VehNo === String(vehNo)) {
                                            setDispatchVehicleID(props.vehData[i].iVehicleID);
                                            setDispatchDriverID(props.vehData[i].iDriverID);
                                            setinvokeDispatchComponent(true);
                                            // Break the loop if the condition is met
                                            break;
                                            }
                                        }
                                    }
                                });
                            });
                            setvehicleTableCreated(true);
                        }
                        else
                        {
                            console.log("CabDispatchTable null exp");
                        }
                        
                    }
                }
            }
            /// Vehicle Dispatch Section
            
            
            //setTimeout(() => {
                
            if(places.length > 0 && places !== null)
            {
              
                const bounds = getMapBounds(map, maps, places, "single");
                if(MapInfoDivCreated)
                {
                    if(places[0].Route !== "")
                    {
                        if(MapPreviousInfoDivCreated)
                        {
                            setMapPreviousInfoDivCreated(false);
                            removeMapDiv(map, maps, {location: ['TOP_LEFT'], index: [0]});
                            // if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                            // {
                            //     map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                            // }
                        }
                        let estMilesTot = 0;
                        let estTimeTot = 0;
                        let tripCount = 0;
                        let passCount = [];
                        for(let i = 0; i < places.length; i++)
                        {
                            estMilesTot+= parseFloat(places[i].EstDistFromPrev);
                            estTimeTot+= parseFloat(places[i].EstTimeFromPrev);
                            if(places[i].Type.toUpperCase() === "PU" || places[i].Type.toUpperCase() === "DO")
                            {
                                tripCount+=1;
                                passCount.push(places[i].PUPerson);
                            }
                        }
                        passCount = [...new Set(passCount)];
                        tripCount = tripCount/2;
                        let content = [tripCount, estMilesTot, estTimeTot, passCount.length];
                        removeMapDiv(map, maps, {location: ['TOP_LEFT'], index: [0]});
                        // if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                        // {
                        //     map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                        // }
                        const infoDiv = createMapInfoDiv(map, maps, places, content); 
                        map.controls[maps.ControlPosition.TOP_LEFT].push(infoDiv);
                        
                    }
                    else
                    {
                        removeMapDiv(map, maps, {location: ['TOP_LEFT'], index: [0]});
                    }
                }
              
                if(places[0].Route === "")         //single trips
                {
                    if(places[0].dLatitude !== null && places[0].dLatitude !== "" && parseFloat(places[0].dLatitude) !== 0 && parseFloat(places[1].dLatitude) !== 0)
                    {
                        if(addedUnroutedTrip.current && addedUnroutedTrip.current.data !== '' && additionalTrip.current !== null && additionalTrip.current.length > 0)
                        {
                            singleRoutePolylineRef.current = [];
                            if(additionalTrip.current[0].trips === undefined)       //single unrouted selected trip
                            {
                                additionalTrip.current[0].trip.forEach((place) => {
        
                                    if (place.Type === "PU"){
            
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'PU'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
            
                                    }
            
                                    else if(place.Type === "DO"){
                                        if(additionalTrip.current[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
            
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerDOIcon
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'DO'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                                        }
                                    }
                                });
                                
                                    
                                for(let i = 0; i < PolyPaths.length; i++) {
                                    PolyPaths[i].setMap(null);
                                }
                                let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(additionalTrip.current[0].trip[0].dLatitude),parseFloat(additionalTrip.current[0].trip[0].dLongitude))
                                    ,latlngDO:new maps.LatLng(parseFloat(additionalTrip.current[0].trip[1].dLatitude),parseFloat(additionalTrip.current[0].trip[1].dLongitude))};
                                
                                let polyPath = new maps.Polyline({
                                    path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                    geodesic: true,
                                    strokeColor: "brown",
                                    strokeOpacity: 0.9,
                                    strokeWeight: 2,
                                });
                                polyPath.setMap(map);
                                PolyPaths.push(polyPath);
                                singleRoutePolylineRef.current.push(polyPath);
                                setPolyPaths(PolyPaths);
                            }
                            else        //multi unrouted selected
                            {
                                additionalTrip.current[0].trips.forEach((item) => {
                                    item.forEach((place)=>{
                                        if (place.Type === "PU"){
            
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerIcon,
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'PU'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                
                                        }
                                        else if(place.Type === "DO"){
                                            if(place.dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
                
                                                markers.push(new maps.Marker({
                                                    position: {
                                                    lat: parseFloat(place.dLatitude),
                                                    lng: parseFloat(place.dLongitude),
                                                    },
                                                    label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                    map,
                                                    icon: UnroutedMarkerDOIcon,
                                                }));
                                                infowindows.push(new maps.InfoWindow({
                                                    content: getInfoWindowString(place, 'DO'),
                                                }));
                                                bounds.extend(new maps.LatLng(
                                                    parseFloat(place.dLatitude),
                                                    parseFloat(place.dLongitude),
                                                ));
                                            }
                                        }
                                    });
                                
                                });
                                
                                    
                                for(let i = 0; i < PolyPaths.length; i++) {
                                    PolyPaths[i].setMap(null);
                                }
                                additionalTrip.current[0].trips.forEach((item) => {
                                    let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(item[0].dLatitude),parseFloat(item[0].dLongitude))
                                        ,latlngDO:new maps.LatLng(parseFloat(item[1].dLatitude),parseFloat(item[1].dLongitude))};
                                    
                                    let polyPath = new maps.Polyline({
                                        path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                        geodesic: true,
                                        strokeColor: "brown",
                                        strokeOpacity: 0.9,
                                        strokeWeight: 2,
                                    });
                                    polyPath.setMap(map);
                                    singleRoutePolylineRef.current.push(polyPath);
                                    PolyPaths.push(polyPath);
                                });
                                
                                setPolyPaths(PolyPaths);
                            }
                            
                            let lineDict = {latlngPU: new maps.LatLng(parseFloat(places[0].dLatitude),parseFloat(places[0].dLongitude))
                                ,latlngDO:new maps.LatLng(parseFloat(places[1].dLatitude),parseFloat(places[1].dLongitude))};
                            
                            let polyPath = new maps.Polyline({
                                path: [lineDict.latlngPU, lineDict.latlngDO],
                                geodesic: true,
                                strokeColor: "black",
                                strokeOpacity: 0.9,
                                strokeWeight: 3,
                            });
                            polyPath.setMap(map);
                            PolyPaths.push(polyPath);
                            setPolyPaths(PolyPaths);
                        
                        }
                        else
                        {
                            for(let i = 0; i < PolyPaths.length; i++) {
                                PolyPaths[i].setMap(null);
                            }
                            let lineDict = {latlngPU: new maps.LatLng(parseFloat(places[0].dLatitude),parseFloat(places[0].dLongitude))
                                ,latlngDO:new maps.LatLng(parseFloat(places[1].dLatitude),parseFloat(places[1].dLongitude))};
                            
                            let polyPath = new maps.Polyline({
                                path: [lineDict.latlngPU, lineDict.latlngDO],
                                geodesic: true,
                                strokeColor: "black",
                                strokeOpacity: 0.9,
                                strokeWeight: 3,
                            });
                            polyPath.setMap(map);
                            PolyPaths.push(polyPath);
                            setPolyPaths(PolyPaths);
                        }
                        
                    }
                }
                else            //multi-trips
                {
                
                    if(addedUnroutedTrip.current && addedUnroutedTrip.current.data !== '' && additionalTrip.current !== null && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current = [];
                        if(additionalTrip.current[0].trips === undefined)       //single unrouted selected trip
                        {
                            additionalTrip.current[0].trip.forEach((place) => {
    
                                if (place.Type === "PU"){
        
                                    markers.push(new maps.Marker({
                                        position: {
                                        lat: parseFloat(place.dLatitude),
                                        lng: parseFloat(place.dLongitude),
                                        },
                                        label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                        map,
                                        icon: UnroutedMarkerIcon,
                                    }));
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(place, 'PU'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(place.dLatitude),
                                        parseFloat(place.dLongitude),
                                    ));
        
                                }
        
                                else if(place.Type === "DO"){
                                    if(additionalTrip.current[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
        
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerDOIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'DO'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
                                    }
                                }
                            });
                            
                                
                            for(let i = 0; i < PolyPaths.length; i++) {
                                PolyPaths[i].setMap(null);
                            }
                            let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(additionalTrip.current[0].trip[0].dLatitude),parseFloat(additionalTrip.current[0].trip[0].dLongitude))
                                ,latlngDO:new maps.LatLng(parseFloat(additionalTrip.current[0].trip[1].dLatitude),parseFloat(additionalTrip.current[0].trip[1].dLongitude))};
                            
                            let polyPath = new maps.Polyline({
                                path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                geodesic: true,
                                strokeColor: "brown",
                                strokeOpacity: 0.9,
                                strokeWeight: 2,
                            });
                            polyPath.setMap(map);
                            PolyPaths.push(polyPath);
                            singleRoutePolylineRef.current.push(polyPath);
                            setPolyPaths(PolyPaths);
                        }
                        else        //multi unrouted selected
                        {
                            additionalTrip.current[0].trips.forEach((item) => {
                                item.forEach((place)=>{
                                    if (place.Type === "PU"){
        
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'PU'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
            
                                    }
                                    else if(place.Type === "DO"){
                                        if(place.dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
            
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerDOIcon,
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'DO'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                                        }
                                    }
                                });
                                
                            });
                            
                                
                            for(let i = 0; i < PolyPaths.length; i++) {
                                PolyPaths[i].setMap(null);
                            }
                            additionalTrip.current[0].trips.forEach((item) => {
                                let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(item[0].dLatitude),parseFloat(item[0].dLongitude))
                                    ,latlngDO:new maps.LatLng(parseFloat(item[1].dLatitude),parseFloat(item[1].dLongitude))};
                                
                                let polyPath = new maps.Polyline({
                                    path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                    geodesic: true,
                                    strokeColor: "brown",
                                    strokeOpacity: 0.9,
                                    strokeWeight: 2,
                                });
                                polyPath.setMap(map);
                                singleRoutePolylineRef.current.push(polyPath);
                                PolyPaths.push(polyPath);
                            });
                            
                            setPolyPaths(PolyPaths);
                        }
                        
            
                        getStraightPolylines(newPathArray, map, maps);
                    }
                    else
                    {
                        for(let i = 0; i < PolyPaths.length; i++) {
                            PolyPaths[i].setMap(null);
                        }
                        getStraightPolylines(newPathArray, map, maps);
                    }
                    // newPathArray.sort(function(a,b){                                              //Sorted
                    //     return a.time.localeCompare(b.time);
                    // });
                    // getAPIPolyLines(newPathArray, maps);
                    
                    
                }

            

                
                if(props.vehData && props.vehData.length > 0 && vehImage.current.length > 0)
                {
                    if (props.vehData.length === 1) 
                    {
                        if (props.vehData?.[0]?.hasOwnProperty("ServiceStatus")) 
                        {
                            PlotSingleVehicleOnMap(map, maps);
                            const vehicle = props.vehData[0];
                            const driverLat = parseFloat(vehicle?.DriverLocationLatitude);
                            const driverLng = parseFloat(vehicle?.DriverLocationLongitude);

                            if (!isNaN(driverLat) && !isNaN(driverLng)) {
                            bounds.extend(new maps.LatLng(driverLat, driverLng));
                            } else {
                            console.warn("Invalid driver coordinates:", driverLat, driverLng);
                            }
                        } 
                        else 
                        {
                            if(props.TripType?.current !== "Routed-2")
                            {
                                if (props.vehData[0]?.STATE?.toUpperCase() !== "OFFLINE" && props.vehData[0]?.STATE?.toUpperCase() !== "DISCONNECTED") 
                                {
                                    if (props.vehData[0]?.STATE?.toUpperCase() === "IRTPU" || props.vehData[0]?.STATE?.toUpperCase() === "DISPATCHED"
                                        || props.vehData[0]?.STATE?.toUpperCase() === "ACCEPTED") 
                                    {
                                        let marker = CreateVehicleMarker(map, maps, props.vehData[0].DriverLocationLatitude, props.vehData[0].DriverLocationLongitude, 'dispatched_Vehicle', 0);
                                        markers.push(marker);
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(props.vehData[0], 'vehicle', true),
                                        }));
                                    } 
                                    else
                                    {
                                        //Discussed following check with Muaaz and after discussion commenting below distance check. 
                                        //if (parseFloat(props.vehData[0].Distance) < 20) {
                                            let marker = CreateVehicleMarker(map, maps, props.vehData[0].LATITUDE, props.vehData[0].LONGITUDE, 'dispatched_Vehicle');
                                            markers.push(marker);
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(props.vehData[0], 'vehicle', true),
                                            }));
                                        //}
                                    }
                                }
                                else if(props.vehData[0]?.STATE?.toUpperCase() === "OFFLINE" && props.vehData[0]?.STATE?.toUpperCase() === "DISCONNECTED"){
                                    //--New Section
                                    //TO-DO
                                }
                            }
                        }
                        
                    }
                    else 
                    {
                        if(props.TripType?.current == "Routed-0"){ // 0 Means Para/Taxi
                            for(let k = 0; k < props.vehData.length; k++)
                            {
                                if(props.vehData[k].STATE !== "OFFLINE" && props.vehData[k].STATE !== "DISCONNECTED" && parseFloat(props.vehData[k].Distance) < 20)
                                {

                                    let marker = CreateVehicleMarker(map, maps, props.vehData[k].LATITUDE, props.vehData[k].LONGITUDE, 'dispatched_Vehicle', k);
                                    markers.push(marker);
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(props.vehData[k], 'vehicle'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(props.vehData[k].LATITUDE),
                                        parseFloat(props.vehData[k].LONGITUDE),
                                    ));
                                }
                            }
                        }
                    }
                }

                if(props.TripType?.current == "Routed-0" || props.TripType?.current == "Routed-2"){
                    plotOnMap(0, places, map, maps, true, selectedSingleRow);
                    //return;
                }
                // if(props.TripType?.current == "Routed-0"){
                //     plotOnMap(0, places, map, maps, true);
                //     //return;
                // }

                if(bounds && !bounds.isEmpty())
                {
                   
                    setTimeout(() => {
                        if(places?.length > 0 && selectedSingleRow == undefined ){
                            map.fitBounds(bounds); //IMPORTANT do NOT comment out unless you dont want to auto-focus on double-clicked routed trips - Kamran A
                        }
                    }, 1000);
                
                    if(places?.length > 0 && selectedSingleRow != undefined && selectedSingleRow[0]?.IsRowSelected){
                        
                        let dLatitude = selectedSingleRow[0].dLatitude;
                        let dLongitude = selectedSingleRow[0].dLongitude;
                        if(dLatitude != undefined && dLongitude != undefined){
                            map.setCenter(new  maps.LatLng(parseFloat(dLatitude), parseFloat(dLongitude)));
                        }
                    }
                }
            } 
            else // UnRouted Trips Area
            {   
                //Unrouted Trip clicked
                if(singleClickUnroutedTrips.current?.data !== '' && additionalTrip.current !== null && additionalTrip.current.length > 0)
                {
                    RemoveShowCompletedCheckBoxFromMap(map, maps);
                    let bounds = null;
                    markers.length = 0;
                    infowindows.length = 0;
                    singleRoutePolylineRef.current = [];
                    if(additionalTrip.current[0].trips === undefined)       //single unrouted selected trip
                    {
                        bounds = getMapBounds(map, maps, additionalTrip.current[0].trip, "single");
                        additionalTrip.current[0].trip.forEach((place) => {

                            if (place.Type === "PU"){
    
                                markers.push(new maps.Marker({
                                    position: {
                                    lat: parseFloat(place.dLatitude),
                                    lng: parseFloat(place.dLongitude),
                                    },
                                    label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                    map,
                                    icon: UnroutedMarkerIcon,
                                }));
                                infowindows.push(new maps.InfoWindow({
                                    content: getInfoWindowString(place, 'PU'),
                                }));
                                bounds.extend(new maps.LatLng(
                                    parseFloat(place.dLatitude),
                                    parseFloat(place.dLongitude),
                                ));
    
                            }
    
                            else if(place.Type === "DO"){
                                if(additionalTrip.current[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
    
                                    markers.push(new maps.Marker({
                                        position: {
                                        lat: parseFloat(place.dLatitude),
                                        lng: parseFloat(place.dLongitude),
                                        },
                                        label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                        map,
                                        icon: UnroutedMarkerDOIcon,
                                    }));
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(place, 'DO'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(place.dLatitude),
                                        parseFloat(place.dLongitude),
                                    ));
                                }
                            }
                        });
                        
                            
                        for(let i = 0; i < PolyPaths.length; i++) {
                            PolyPaths[i].setMap(null);
                        }
                        let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(additionalTrip.current[0].trip[0].dLatitude),parseFloat(additionalTrip.current[0].trip[0].dLongitude))
                            ,latlngDO:new maps.LatLng(parseFloat(additionalTrip.current[0].trip[1].dLatitude),parseFloat(additionalTrip.current[0].trip[1].dLongitude))};
                        
                        let polyPath = new maps.Polyline({
                            path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                            geodesic: true,
                            strokeColor: "brown",
                            strokeOpacity: 0.9,
                            strokeWeight: 2,
                        });
                        polyPath.setMap(map);
                        PolyPaths.push(polyPath);
                        singleRoutePolylineRef.current.push(polyPath);
                        setPolyPaths(PolyPaths);
                    }
                    else        ///////////////////////Multile selection for unrouted trips
                    {
                        bounds = getMapBounds(map, maps, additionalTrip.current[0].trips, "multiple");
                        additionalTrip.current[0].trips.forEach((item) => {
                            item.forEach((place)=>{
                                if (place.Type === "PU"){
    
                                    markers.push(new maps.Marker({
                                        position: {
                                        lat: parseFloat(place.dLatitude),
                                        lng: parseFloat(place.dLongitude),
                                        },
                                        label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                        map,
                                        icon: UnroutedMarkerIcon,
                                    }));
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(place, 'PU'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(place.dLatitude),
                                        parseFloat(place.dLongitude),
                                    ));
        
                                }
                                else if(place.Type === "DO"){
                                    if(place.dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
        
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerDOIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'DO'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
                                    }
                                }
                            });
                        
                        });
                        
                            
                        for(let i = 0; i < PolyPaths.length; i++) {
                            PolyPaths[i].setMap(null);
                        }
                        additionalTrip.current[0].trips.forEach((item) => {
                            let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(item[0].dLatitude),parseFloat(item[0].dLongitude))
                                ,latlngDO:new maps.LatLng(parseFloat(item[1].dLatitude),parseFloat(item[1].dLongitude))};
                            
                            let polyPath = new maps.Polyline({
                                path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                geodesic: true,
                                strokeColor: "brown",
                                strokeOpacity: 0.9,
                                strokeWeight: 2,
                            });
                            polyPath.setMap(map);
                            singleRoutePolylineRef.current.push(polyPath);
                            PolyPaths.push(polyPath);
                        });
                        
                        setPolyPaths(PolyPaths);
                    }
                    if(props.vehData && props.vehData.length > 0 && vehImage.current.length > 0) {
                        let vehData = props.vehData;      
                        if (vehData.length === 1) {
                            if (vehData?.[0]?.hasOwnProperty("ServiceStatus")) 
                            {
                                PlotSingleVehicleOnMap(map, maps);
                                const vehicle = props.vehData[0];
                                const driverLat = parseFloat(vehicle?.DriverLocationLatitude);
                                const driverLng = parseFloat(vehicle?.DriverLocationLongitude);
                                
                                if (!isNaN(driverLat) && !isNaN(driverLng)) {
                                  bounds.extend(new maps.LatLng(driverLat, driverLng));
                                } else {
                                  console.warn("Invalid driver coordinates:", driverLat, driverLng);
                                }
                            } 
                            else
                            {
                                if (vehData[0]?.STATE?.toUpperCase() !== "OFFLINE" && vehData[0]?.STATE?.toUpperCase() !== "DISCONNECTED") {
                                    if (vehData[0]?.STATE?.toUpperCase() === "IRTPU" || vehData[0]?.STATE?.toUpperCase() === "DISPATCHED"
                                        || vehData[0]?.STATE?.toUpperCase() === "ACCEPTED") 
                                    {
                                        let marker = CreateVehicleMarker(map, maps, props.vehData[0].DriverLocationLatitude, props.vehData[0].DriverLocationLongitude, 'dispatched_Vehicle', 0);
                                        markers.push(marker);
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(vehData[0], 'vehicle', true),
                                        }));
                                        const vehicle = props.vehData[0];
                                        const driverLat = parseFloat(vehicle?.DriverLocationLatitude);
                                        const driverLng = parseFloat(vehicle?.DriverLocationLongitude);
            
                                        if (!isNaN(driverLat) && !isNaN(driverLng)) {
                                        bounds.extend(new maps.LatLng(driverLat, driverLng));
                                        } else {
                                        console.warn("Invalid driver coordinates:", driverLat, driverLng);
                                        }
                                    } 
                                    else 
                                    {
                                        //Discussed following check with Muaaz and after discussion commenting below distance check. 
                                        //if (parseFloat(vehData[0].Distance) < 20) {}
        
                                        let marker = CreateVehicleMarker(map, maps, props.vehData[0].LATITUDE, props.vehData[0].LONGITUDE, 'dispatched_Vehicle', 0);
                                        markers.push(marker);
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(vehData[0], 'vehicle', true),
                                        }));
                                        const vehicle = props.vehData[0];
                                        const driverLat = parseFloat(vehicle?.LATITUDE);
                                        const driverLng = parseFloat(vehicle?.LONGITUDE);
            
                                        if (!isNaN(driverLat) && !isNaN(driverLng)) {
                                        bounds.extend(new maps.LatLng(driverLat, driverLng));
                                        } else {
                                        console.warn("Invalid driver coordinates:", driverLat, driverLng);
                                        }
                                    }
        
                                    // bounds.extend(new maps.LatLng(
                                    //     parseFloat(vehData[k].DriverLocationLatitude),
                                    //     parseFloat(vehData[k].DriverLocationLongitude),
                                    // ));
                                }
                            }
                            
                        }
                        else {
                            for(let k = 0; k < vehData.length; k++)
                            {
                                if(vehData[k].STATE !== "OFFLINE" && vehData[k].STATE !== "DISCONNECTED" && parseFloat(vehData[k].Distance) < 20)
                                {
                                    let marker = CreateVehicleMarker(map, maps, vehData[k].LATITUDE, vehData[k].LONGITUDE, 'dispatched_Vehicle', k);
                                    markers.push(marker);
        
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(vehData[k], 'vehicle'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(vehData[k].LATITUDE),
                                        parseFloat(vehData[k].LONGITUDE),
                                    ));
                                }
                            }
                        }
                    }
                    else
                    {
                        if(vehicleTableCreated) // && map.controls[maps.ControlPosition.LEFT_TOP].length > 0
                        {
                            removeMapDiv(map, maps, {location: ['LEFT_TOP'], index: [0]});
                            // map.controls[maps.ControlPosition.LEFT_TOP].removeAt(0);
                            setvehicleTableCreated(false);
                        }
                    }
                    
                    if(bounds && !bounds.isEmpty())
                    {
                        setTimeout(() => {
                            map.fitBounds(bounds); //IMPORTANT do NOT comment out unless you dont want to auto-focus on multi un-routed trips - Kamran A
                        }, 1000);
                    }
                }    
            }
            
            let actualMarkersList = markers;
            actualMarkersList.forEach((marker, i) => {
                oms.addMarker(marker);
                marker.addListener('mouseover', () => {
                    infowindows[i].open(map, marker);
                });
                marker.addListener("mouseout", () => {
                    infowindows[i].close();
                });
                marker.addListener('click', ()=>{
                    try{
                        marker.setAnimation(maps.Animation.BOUNCE);
                        stopAnimation(marker);
                
                        // Animate matching markers by name
                        for (let i = 0; i < actualMarkersList.length; i++) {
                            const current = actualMarkersList[i];
                            if (current.label?.name === marker.label?.name && current !== marker) {
                                current.setAnimation(maps.Animation.BOUNCE);
                                stopAnimation(current);
                            } else if (current !== marker) {
                                current.setAnimation(null);
                            }
                        }
                
                        // Only pan to the marker if it's outside the visible bounds
                        const bounds = map.getBounds();
                        const markerPosition = marker.getPosition();
                        if (bounds && !bounds.contains(markerPosition)) {
                            map.panTo(markerPosition);
                
                            // Only adjust zoom if zoom is unlocked
                            if (!zoomOpt.zoomControl) {
                                map.setZoom(16);
                            }
                        }
                       
                    }
                    catch(err){console.log(err);}
                });

            });
            // map.setCenter(state.center);
            // setPolyPaths(PolyPaths);
            
            if(markers.length > 0)
            {

                const controls = map.controls[maps.ControlPosition.LEFT_BOTTOM].getArray();

                // Iterate over all controls and remove those whose id contains the substring
                for (let i = 0; i < controls.length; i++) {
                    const control = controls[i];
                    if (control.id && control.id.includes("_vehicleMapDiv")) {
                        map.controls[maps.ControlPosition.LEFT_BOTTOM].removeAt(i);
                        i--; // Adjust index after removal to avoid skipping the next control
                    }
                }

                if (props.vehData.length === 0 )//&& singleClickUnroutedTrips?.current?.data?.length == 0 && selectedSingleRow?.length == 0)
                {
                    removeMarkersByClass('dispatched_Vehicle');
                }
                const vehicleOption = createVehicleBtn(map, maps, markers);
                const vehicleDiv = CommonFunctions.CreateElement('div', {
                    styles: {
                        margin: '10px'
                    },
                    attributes:{
                        id: state.GridName+"_vehicleMapDiv"
                    },
                    children: [vehicleOption]
                });
                // const vehicleDiv = document.createElement("div");
                // vehicleDiv.id = state.GridName + "_vehicleMapDiv";
                // vehicleDiv.style.margin = "10px";

                // vehicleDiv.appendChild(vehicleOption);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(vehicleDiv);

            }
            setMarkers(markers);
            setinfowindows(infowindows);

            ShowOccupiedVehiclesCheckBoxOnMap(map, maps);
        }
        catch(err){console.log(err);} 
    };

    function ShowOccupiedVehiclesCheckBoxOnMap(map, maps){
        try {
            const controls = map.controls[maps.ControlPosition.LEFT_BOTTOM].getArray();
            for (let i = 0; i < controls.length; i++) {
                const control = controls[i];
                if (control.id && control.id.includes("_ShowOccupiedVehiclesCheckboxMap")) {
                    map.controls[maps.ControlPosition.LEFT_BOTTOM].removeAt(i);
                    i--;
                }
            }
            const occupiedVehiclesCheckBox = createShowOccupiedVehiclesCheckBox(map, maps);
            const occupiedVehiclesDiv = CommonFunctions.CreateElement('div', {
                styles: {
                    margin: '10px'
                },
                attributes:{
                    id: state.GridName+"_ShowOccupiedVehiclesCheckboxMap"
                },
                children: [occupiedVehiclesCheckBox]
            });
            // const occupiedVehiclesDiv = document.createElement("div");
            // occupiedVehiclesDiv.id = state.GridName + "_ShowOccupiedVehiclesCheckboxMap";
            // occupiedVehiclesDiv.style.margin = "10px";
            // occupiedVehiclesDiv.appendChild(occupiedVehiclesCheckBox);
            map.controls[maps.ControlPosition.LEFT_BOTTOM].push(occupiedVehiclesDiv);
            IsShowOccupiedVehiclesCheckBoxAdded.current = true;
        } catch (error) {
            
        }
    }

    function ShowCompletedTripsMapButton(map, maps){
        try {
            const controlPosition = maps.ControlPosition.RIGHT_TOP;
            const controlArray = map.controls[controlPosition];
        
            if (controlArray.getLength() > 0) {
                for (let i = 0; i < controlArray.getLength(); i++) {
                    if (controlArray.getAt(i).id === state.GridName + "_completedMapDiv") {
                        controlArray.removeAt(i);
                        break;
                    }
                }
            }
            const showCompletedTrips = createShowCompletedCheckBox();
            const ShowCompletedDiv = CommonFunctions.CreateElement('div', {
                styles: {
                    margin: '10px'
                },
                attributes:{
                    id: state.GridName+"_completedMapDiv"
                },
                children: [showCompletedTrips]
            });
            // const ShowCompletedDiv = document.createElement("div");
            let filteredData= AffiliateData.filter(item => String(item.AffiliateID) === props.selectedAffiliates.toString());
            let iTransType = (filteredData[0].iTransType !== 0);
            if(IsCalledFromAffiliateChange.current){
                setIsShowCompleted((!iTransType));
            }
            IsCalledFromAffiliateChange.current = false;
            
            
            // ShowCompletedDiv.id = state.GridName +"_completedMapDiv";
            // ShowCompletedDiv.style.margin = "10px";
            // ShowCompletedDiv.appendChild(showCompletedTrips);
            MapShowCompletedRef.current = ShowCompletedDiv;
            map.controls[maps.ControlPosition.RIGHT_TOP].push(ShowCompletedDiv);
        } catch (error) {
            
        }
    }

    const getStraightPolylines = (routeStops, map, maps) =>{
        let temp1DSequence = [];
        let line = null;
        
        for(let i = 0; i < routeStops.length; i++)
        {
            if(routeStops[i]["trip"] === "P")
            {
                temp1DSequence.push(routeStops[i]["trip"]);
            }
            if(i !== (routeStops.length - 1))
            {
                
                if(routeStops[i]["trip"] === "D")
                {
                    if (temp1DSequence.length > 0) {
                        temp1DSequence.shift();
                    }
                    if(temp1DSequence.length === 0)
                    {
                        let lineSymbol = {
                            strokeColor: "purple",
                            path: 'M 0,-1 0,1',
                            strokeOpacity: 0.8,
                            scale: 3
                        };
                        line = new maps.Polyline({
                            path: [routeStops[i]["latLng"], routeStops[i+1]["latLng"]],
                            strokeOpacity: 0,
                            icons: [{
                                icon: lineSymbol,
                                offset: '10px',
                                repeat: '15px'
                            }],
                            strokeWeight: 2
                        });
                        //let ndirectionsapi = directionsapi + "origin="+fullLatLngInfo[i]["LocationInfo"].lat()+"%2C"+fullLatLngInfo[i]["LocationInfo"].lng()+"&destination="+fullLatLngInfo[i+1]["LocationInfo"].lat()+"%2C"+fullLatLngInfo[i+1]["LocationInfo"].lng()+"&AppType=GPS";
                        // await getPolyLines(ndirectionsapi, lineSymbol, 2);
                    }
                    else
                    {
                        line = new maps.Polyline({
                            path: [routeStops[i]["latLng"], routeStops[i+1]["latLng"]],
                            strokeColor: "black",
                            strokeOpacity: 0.9,
                            strokeWeight: 2
                        });
                        // await getPolyLines(ndirectionsapi, "", 2);
                    }
                }
                else
                {
                    line = new maps.Polyline({
                        path: [routeStops[i]["latLng"], routeStops[i+1]["latLng"]],
                        strokeColor: "black",
                        strokeOpacity: 0.9,
                        strokeWeight: 2
                    });
                    // await getPolyLines(ndirectionsapi, "", 2);
                }
                line.setMap(map);
                PolyPaths.push(line);
                setPolyPaths(PolyPaths);
            }
            
        }
    }

    const getAPIPolyLines = async(data, maps) => {
        let xCancelSourceForGrid = APICom.GenerateSource();
        // for(let i = 0; i < data.length; i++)
        // {
        let directionsapi = ITCMapURL.current+"directions?origin="+data[0]["latLng"].lat()+"%2C"+data[0]["latLng"].lng()+"&destination="+data[1]["latLng"].lat()+"%2C"+data[1]["latLng"].lng()+"&AppType=GPS";
        let myHeaders = new Headers();
            myHeaders.append("Authorization", "Basic "+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
        await APICom.fetchData("full", directionsapi, "get", myHeaders, data).then((response) => {
            // let encrptedpolylines = response.data["routes"]["0"]["overview_polyline"]["points"];
            // console.log(response.data);
            // decrpytpoly(encrptedpolylines);
        });
        // }
        
        
    }

    const decrpytpoly = (encrptedpolylines) => {

        let polyline = {};
      
        polyline.decode = function(str, precision) {
            let index = 0,
                lat = 0,
                lng = 0,
                coordinates = [],
                shift = 0,
                result = 0,
                byte = null,
                latitude_change,
                longitude_change,
                factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
      
            // Coordinates have variable length when encoded, so just keep
            // track of whether we've hit the end of the string. In each
            // loop iteration, a single coordinate is decoded.
            while (index < str.length) {
      
                // Reset shift, result, and byte
                byte = null;
                shift = 0;
                result = 0;
      
                do {
                    byte = str.charCodeAt(index++) - 63;
                    result |= (byte & 0x1f) << shift;
                    shift += 5;
                } while (byte >= 0x20);
      
                latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      
                shift = result = 0;
      
                do {
                    byte = str.charCodeAt(index++) - 63;
                    result |= (byte & 0x1f) << shift;
                    shift += 5;
                } while (byte >= 0x20);
      
                longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      
                lat += latitude_change;
                lng += longitude_change;
      
                coordinates.push([lat / factor, lng / factor]);
            }
      
            return coordinates;
        };
      
      
        let decryptedpolylines = polyline.decode(encrptedpolylines);
        let polycoord = [];
        for(let i = 0; i < decryptedpolylines.length; i++){
            let latlong = {};
            latlong["lat"] = decryptedpolylines[i][0];
            latlong["lng"] = decryptedpolylines[i][1];
            polycoord.push(latlong);
        }
        
        return polycoord;
    }

    const RemoveAllMapObjects = (selectedSingleRowCluster, removeVehicle = true) => {
        
        if(!keepZoneRef.current){
            for(let i = 0; i < polygons.length; i++) {
                polygons[i].setMap(null);
            }
        }

        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }

        // Vehicle removal section
        // const dispatchedMarkers = [];
        // const otherMarkers = [];

        // for (let i = 0; i < markers.length; i++) {
        //     if (markers[i].className === "dispatched_Vehicle" && !removeVehicle) {
        //         dispatchedMarkers.push(markers[i]);
        //     } else {
        //         otherMarkers.push(markers[i]);
        //     }
        // }

        // // Remove the other markers from the map
        // otherMarkers.forEach(marker => {
        //     marker.setMap(null);
        // });
        // Vehicle removal section


        for(let i = 0; i < PolyPaths.length; i++) {
            PolyPaths[i].setMap(null);
        }
        for(let i = 0; i < infowindows.length; i++) {
            infowindows[i].setMap(null);
        }

        markers.length = 0;
        infowindows.length = 0;
        PolyPaths.length = 0;
    }

    // Update localStorage when zoom or center changes
    const handleMapChange = ({ zoom, center }) => {

        PersistStorage.save("lastUserZoomLevel", zoom, 999, false);
        // PersistStorage.save("lastUserMapCenterLat", mapCenterRef.current.lat, 999, false);
        // PersistStorage.save("lastUserMapCenterLong", mapCenterRef.current.lng, 999, false);
        props.setIsFromDoubleClick(false)
       

    };

    const createShowCompletedCheckBox = () => {

        
        // const completedTripsDiv = document.createElement("div");
        // completedTripsDiv.style.display = "flex";
        // completedTripsDiv.style.alignItems = "center";
        // completedTripsDiv.style.gap = "5px";
        // completedTripsDiv.style.borderRadius= "50%";
        // completedTripsDiv.style.background= "rgb(0 0 0 / 59%)";
        // completedTripsDiv.style.padding= "2px";
        const vehicleCheckbox = CommonFunctions.CreateElement('input', {
            styles: {
                cursor: 'pointer'
            },
            attributes:{
                id: state.GridName+"_ShowCompletedCheckboxMap",
                type: 'checkbox'
            },
            classes: ['d-flex']
        });

        // const vehicleCheckbox = document.createElement("input");
        // vehicleCheckbox.type = "checkbox";
        // vehicleCheckbox.id = state.GridName + "_ShowCompletedCheckboxMap";
        // vehicleCheckbox.style.cursor = "pointer";

        const completedTripsImage = CommonFunctions.CreateElement('img', {
            styles: {
                width: '30px',
                height: '30px'
            },
            attributes:{
                id: state.GridName+"_ShowCompletedCheckboxMap",
                alt: "Completed Trips",
                src: (IsShowCompleted ? completedCheck : completedCheck2)
            },
        });

        const completedTripsButton = CommonFunctions.CreateElement('button', {
            styles: {
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: 0
            },
            attributes:{
                id: state.GridName+"_ShowCompletedButtonMap",
                title: (IsShowCompleted ? "Hide Completed Trips": "Show Completed Trips")
            },
            children: [completedTripsImage]
        });

        const completedTripsDiv = CommonFunctions.CreateElement('div', {
            styles: {
                margin: 0,
                alignItems: 'center',
                gap: '5px',
                borderRadius: '50%',
                background: "rgb(0 0 0 / 59%)",
                padding: '2px'
            },
            classes: ['d-flex'],
            children: [completedTripsButton]
        });

        // const completedTripsButton = document.createElement("button");
        // completedTripsButton.style.border = "none";
        // completedTripsButton.style.background = "transparent";
        // completedTripsButton.style.cursor = "pointer";
        // completedTripsButton.style.padding = "0";
        // completedTripsButton.id = state.GridName + "_ShowCompletedButtonMap";
        // completedTripsButton.title = IsShowCompleted ? "Hide Completed Trips": "Show Completed Trips";
      

  
        // const completedTripsImage = document.createElement("img");
        // completedTripsImage.src = IsShowCompleted ? completedCheck : completedCheck2;
        // completedTripsImage.alt = "Completed Trips";
        // completedTripsImage.style.width = "30px";
        // completedTripsImage.style.height = "30px";
        // completedTripsImage.id = state.GridName + "_ShowCompletedCheckboxMap";

        // completedTripsButton.appendChild(completedTripsImage);

        completedTripsButton.addEventListener("click", () => {
            if (completedTripsImage.src.includes(completedCheck)) {
                completedTripsImage.src = completedCheck2;
                completedTripsButton.title = "Show Completed Trips";
                props.setCheckCompletedTrips(false);
                setIsShowCompleted(false);
                toast.info("Show Completed Trips Disabled.");
            } else {
                completedTripsImage.src = completedCheck;
                completedTripsButton.title = "Hide Completed Trips";
                props.setCheckCompletedTrips(true);
                setIsShowCompleted(true);
                toast.success("Show Completed Trips Enabled.");
            }
        });

        // completedTripsDiv.appendChild(completedTripsButton);

        return completedTripsDiv;
    }


    const createShowOccupiedVehiclesCheckBox = (map, maps) => {

        const controlPosition = maps.ControlPosition.LEFT_BOTTOM;
        const controlArray = map.controls[controlPosition];
    
        if (controlArray.getLength() > 0) {
            for (let i = 0; i < controlArray.getLength(); i++) {
                if (controlArray.getAt(i).id === state.GridName + "_ShowOccupiedVehiclesCheckboxMap") {
                    controlArray.removeAt(i);
                    break;
                }
            }
        }

        const showOccupiedVehicleInputsAsCheckbox = CommonFunctions.CreateElement('input', {
            styles: {
                width: '25px',
                height: '25px',
                cursor: 'pointer',
                borderRadius: '50%',
                accentColor: (IsShowOccupiedVehcilesChecked ? 'darkorange' : 'white')
            },
            attributes: {
                id: (state.GridName + "_ShowOccupiedVehiclesCheckboxMapInput"),
                type: 'checkbox',
                checked: (IsShowOccupiedVehcilesChecked),
                title: (IsShowOccupiedVehcilesChecked ? "Hide Occupied Vehicles" : "Show Occupied Vehicles")
            }
        });

        const showOccupiedVehiclesCheckbox = CommonFunctions.CreateElement('div', {
            styles: {
                alignItems: 'center',
                gap: '5px',
                borderRadius: '50%',
                padding: '2px'
            },
            classes: ['d-flex'],
            children: [showOccupiedVehicleInputsAsCheckbox]
        });
        // const showOccupiedVehiclesCheckbox = document.createElement("div");

        // showOccupiedVehiclesCheckbox.style.display = "flex";
        // showOccupiedVehiclesCheckbox.style.alignItems = "center";
        // showOccupiedVehiclesCheckbox.style.gap = "5px";
        // showOccupiedVehiclesCheckbox.style.borderRadius = "50%";
        // showOccupiedVehiclesCheckbox.style.padding = "2px";

        // const showOccupiedVehiclesInpustAsCheckbox = document.createElement("input");

        // showOccupiedVehiclesInpustAsCheckbox.type = "checkbox";
        // showOccupiedVehiclesInpustAsCheckbox.id = state.GridName + "_ShowOccupiedVehiclesCheckboxMapInput";
        // showOccupiedVehiclesInpustAsCheckbox.checked = IsShowOccupiedVehcilesChecked;  // initial state
        // showOccupiedVehiclesInpustAsCheckbox.style.width = "25px";
        // showOccupiedVehiclesInpustAsCheckbox.style.height = "25px";
        // showOccupiedVehiclesInpustAsCheckbox.style.cursor = "pointer";
        // showOccupiedVehiclesInpustAsCheckbox.style.borderRadius = "50%";
        // if(IsShowOccupiedVehcilesChecked){
        //     showOccupiedVehiclesInpustAsCheckbox.style.accentColor = "darkorange";
        // }
        // else{
        //     showOccupiedVehiclesInpustAsCheckbox.style.accentColor = "white";
        // }
    
        // showOccupiedVehiclesInpustAsCheckbox.title = IsShowOccupiedVehcilesChecked ? 
        //     "Hide Occupied Vehicles" : "Show Occupied Vehicles";
    
        showOccupiedVehicleInputsAsCheckbox.addEventListener("change", () => {
            if (showOccupiedVehicleInputsAsCheckbox.checked) {
                props.setShowOccupiedVehicles(true);
                setIsShowOccupiedVehcilesChecked(true);
                showOccupiedVehicleInputsAsCheckbox.style.accentColor = "darkorange";
                showOccupiedVehicleInputsAsCheckbox.title = "Hide Occupied Vehicles";
                toast.success("Show Occupied Vehicles Enabled.");
            } else {
                props.setShowOccupiedVehicles(false);
                setIsShowOccupiedVehcilesChecked(false);
                showOccupiedVehicleInputsAsCheckbox.style.accentColor = "white";
                showOccupiedVehicleInputsAsCheckbox.title = "Show Occupied Vehicles";
                toast.info("Show Occupied Vehicles Disabled.");
            }
        });
        // showOccupiedVehiclesCheckbox.appendChild(showOccupiedVehiclesInpustAsCheckbox);

        return showOccupiedVehiclesCheckbox;
    };
    

    const plotOnMap = (TransType = 0, stops, map, maps, IsRoutedTrip = false, selectedStop ) => {
        try {
            switch (TransType) {
                case 0:
                    HandleMapForTaxiAndParaService(stops, map, maps, IsRoutedTrip, selectedStop);
                    break;
                case 2:
                    HandleMapForMicroService();
                    break;
                default:
                    console.warn("Unknown transport type:", TransType);
                    break;
            }
        } catch (error) {
            console.error("Error plotting on map:", error);
        }
    };

    const HandleMapForTaxiAndParaService = (stops, map, maps, IsRoutedTrip = false, selectedStop) => {
        try {
            if(stops?.length > 0){
                if(IsRoutedTrip == true){
                    PlotNodesForRoutedTaxiParaService(stops, map, maps, selectedStop);
                }
                else if(IsRoutedTrip == false){
    
                }
                else{
    
                }
            }
        } catch (error) {
            
        }
    }

    const HandleMapForMicroService = (IsRoutedTrip = false) => {
        try {
            
            if(IsRoutedTrip == true){

            }
            else if(IsRoutedTrip == false){

            }
            else{
                
            }
        } catch (error) {
            
        }
    }

    const PlotNodesForRoutedTaxiParaService = (stops, map, maps, selectedStop) => {
        try {
            // debugger
            let routeStops = [];
            if(stops?.length > 0){                
                stops.forEach((stop) => {
                    if (stop.Type === "PU"){

                        markers.push(new maps.Marker({
                            position: {
                            lat: parseFloat(stop.dLatitude),
                            lng: parseFloat(stop.dLongitude),
                            },
                            label: {text:("P"+stop.iVehStopOrder), className:"fw-bold marker_label_css", name:stop.TripNo},
                            map,
                            icon: stop.bPerformed ? CompletedIcon : PUIcon,
                        }));
                        routeStops.push({trip:"P", latLng: new maps.LatLng(parseFloat(stop.dLatitude),parseFloat(stop.dLongitude)), time: stop.SchTime });
                        infowindows.push(new maps.InfoWindow({
                            content: getInfoWindowString(stop, 'PU'),
                        }));

                    }
                    else if(stop.Type === "DO"){
                        if(stop.dLatitude !== "" && parseFloat(stop.dLatitude) !== 0){
                            if(stop.bPerformed)
                            {
                                markers.push(new maps.Marker({
                                    position: {
                                    lat: parseFloat(stop.dLatitude),
                                    lng: parseFloat(stop.dLongitude),
                                    },
                                    label: {text:("D"+stop.iVehStopOrder), className:"fw-bold marker_label_css", name:stop.TripNo},
                                    map,
                                    icon: CompletedIcon,
                                }));
                            }
                            else
                            {
                                markers.push(new maps.Marker({
                                    position: {
                                    lat: parseFloat(stop.dLatitude),
                                    lng: parseFloat(stop.dLongitude),
                                    },
                                    label: {text:("D"+stop.iVehStopOrder), className:"fw-bold marker_label_css_DO", name:stop.TripNo},
                                    map,
                                }));
                            }
                            routeStops.push({trip:"D", latLng: new maps.LatLng(parseFloat(stop.dLatitude),parseFloat(stop.dLongitude)), time: stop.SchTime });
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(stop, 'DO'),
                            }));
                        }

                    }
                    else if(stop.Type === "StartDept" || stop.Type === "StartDepot")
                    {
                        markers.push(new maps.Marker({
                            position: {
                            lat: parseFloat(stop.dLatitude),
                            lng: parseFloat(stop.dLongitude),
                            },
                            icon:SDepot,
                            map,
                        }));
                        infowindows.push(new maps.InfoWindow({
                            content: getInfoWindowString(stop, 'Depot'),
                        }));
                    }
                    else if(stop.Type === "EndDept" || stop.Type === "EndDepot")
                    {
                        markers.push(new maps.Marker({
                            position: {
                            lat: parseFloat(stop.dLatitude),
                            lng: parseFloat(stop.dLongitude),
                            },
                            icon:EDepot,
                            map,
                        }));
                        infowindows.push(new maps.InfoWindow({
                            content: getInfoWindowString(stop, 'Depot'),
                        }));
                    }
                });

                RemoveMapPolylines();
                SetPolylinesForRoutedTaxiParaService(routeStops, map, maps);
                const bounds = getMapBounds(map, maps, stops, "single");
                if(bounds && !bounds.isEmpty())
                {
                    setTimeout(() => {
                        if(stops?.length > 0 && selectedStop == undefined){
                            map.fitBounds(bounds);
                        }
                    }, 1000);
                }
            }
        } catch (error) {
            
        }
    }

    const RemoveMapPolylines = () => {
        try {
            if(PolyPaths?.length > 0){
                for(let i = 0; i < PolyPaths.length; i++) {
                    PolyPaths[i].setMap(null);
                }
            }
        } catch (error) {
            
        }
    }

    const SetPolylinesForRoutedTaxiParaService = (routeStopsArray, map, maps) => {
        try {
            getStraightPolylines(routeStopsArray, map, maps);
        } catch (error) {
            
        }
    }

    const PlotSingleVehicleOnMap = (map, maps) => 
    {
        try 
        {
            if (props.vehData?.[0]?.hasOwnProperty("ServiceStatus")) 
            {
                const vehicle = props.vehData[0];
                const serviceStatus = vehicle?.ServiceStatus?.toUpperCase();
                const driverLat = vehicle?.DriverLocationLatitude;
                const driverLng = vehicle?.DriverLocationLongitude;

                const dispatchedStatuses = new Set(["IRTPU", "DISPATCHED", "ACCEPTED", "ASSIGNED"]);

                const isDriverLocationValid = driverLat != null && driverLng != null;

                const shouldShowMarker = dispatchedStatuses.has(serviceStatus) || parseFloat(vehicle?.EstimatedDistance) < 20;

                if (shouldShowMarker && isDriverLocationValid) {
                    const createdVehMarker = CreateVehicleMarker(map, maps, driverLat, driverLng, 'dispatched_Vehicle');
                    if (createdVehMarker) {
                        markers.push(createdVehMarker);
                    }

                    infowindows.push(new maps.InfoWindow({
                        content: getInfoWindowString(vehicle, 'vehicle', true),
                    }));
                }
            } 
        } 
        catch (error) 
        {  
        }
    }

    const CreateVehicleMarker = (map, maps, lat, lng, className = 'dispatched_Vehicle', vehImageIndex = 0) => {
        let marker;
        try {
            marker = new maps.Marker({
                position: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                },
                Animation: maps.Animation.DROP,
                icon: new maps.MarkerImage(vehImage.current[vehImageIndex], null, null, null, new maps.Size(24, 28)),
                map
            });
            marker.className = className;
        } catch (error) {
            return undefined;
        }
        return marker;
    }

    const ClusterGridSingleSelection = (map, maps, stops, selectedSingleRow = undefined) => {
        try {
            
        } catch (error) {
            
        }
    }
        
    return(
         <Col xs={12} id={state.GridName + '_mapContainer'} style={{ ...dynamicHeight, height: `calc(${props.height} - 5px)`, padding: 0 }}>
            <GoogleMapReact bootstrapURLKeys={{key:'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI'}} yesIWantToUseGoogleMapApiInternals 
                defaultCenter={{lat:39.16552683625823, lng:-77.16834351718929}} defaultZoom={8} tilt={state.tilt} mapId={state.mapId} options={{gestureHandling: state.options.gestureHandling, 
                    zoomControl: zoomOpt.zoomControl, fullscreenControl: true, streetViewControl:true, rotateControl: false, mapTypeControl: true, draggable: zoomOpt.draggable, scrollwheel: zoomOpt.scrollWheel, disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom}} 
                    onChange={handleMapChange} // Capture zoom and center changes
                    onGoogleApiLoaded={({ map, maps }) => { 
                    handleApiLoaded(map, maps, state.places)
                    setGlobalMapsObjects({map:map, maps:maps});
                    map.setCenter(mapCenterRef.current);
                }
                }>
                    
            </GoogleMapReact>
            {invokeDispatchComponent? (<DispatchAction GridRowData={props.GridRowData} selectedDriver={dispatchDriverID} selectedVehicle={dispatchVehicleID} 
            DispatchVehicleData={props.DispatchVehicleData} DispatchDriverData={props.DispatchDriverData} chkVehicleRequiredRef={false}
            invokeDispatchComponent={invokeDispatchComponent} setinvokeDispatchComponent={UnmountDispatchActionComponent}/>) : ""}
        </Col>
            
    );
};

export default MapControl;